<template>
  <div>
    <mcheader></mcheader>
    <div class="payment pay-load" id="payChannelListId" avalon-events="click:eclick_0_64hideSelectDilog" style="margin-top: 20px"><!--京东支付图标-->
<!--收银台公告 end--><!-- 收银台加载loading -->
      <div class="not-use-content" style="display: none;">
        <h5 class="payment-tips">当前支付方式均不可用，请使用以下方式完成支付</h5>
        <div class="paybox-newcard" style="display: block;">
          <a class="pn-new" href="javascript:;" psa="PCashier_home_newcodeorwy"
             avalon-events="click:eclick_0_64showNewCardWangyin4041">添加新卡 / 网银支付</a>
        </div>
        <h5 class="has-payment-title">已有支付方式</h5></div>
      <div class="paychannelBox">
        <ul class="channelTab" style="display: none;">
          <li class="channelItem active" avalon-events="click:eclick_0_64channelTabClick"><a
            href="javascript:;">个人支付</a></li>
          <li class="channelItem " avalon-events="click:eclick_0_64channelTabClick"><a href="javascript:;">企业支付</a></li>
        </ul>
        <div id="payChanel" class="pay-channel animate-enter animate-enter-active" avalon-events="">
          <div class="paybox paybox-bankCard paybox-couponselect" change-class=" paybox-couponselect" v-for="(item,index) in bank" :key="index">
            <div class="p-wrap"><i class="p-border"></i>
              <div class="p-key"><!-- 支付方式选择 --><span class="p-k-check ui-checkbox-wrap" psa="PCashier_yhk" change-class="" avalon-events="click:eclick_0_64checkToggle">
                <el-radio v-model="radio" ></el-radio>
                <i class="p-k-icon"><img :src="item.imgurl"></i>
                <strong>{{item.name}}</strong></span>
                <!-- 支付方式选择 end --></div>
              <div class="p-value">
                <div class="p-v-line xjk-balance"><span>储蓄卡(5408)</span><span class="p-div">&#8203;</span><!--if--><span
                  class="bb-coupo" psa="PCashier_qxzyh" avalon-events="click:eclick_0_64showCoupon"><i
                  class="bb-coupo-icon">优惠</i><em class="bb-coupo-text"><i>&gt;</i></em></span></div>
                <!--if--></div>
              <div class="p-amount"><em>支付</em><strong>0</strong><em>元</em>
                <div class="pre-val">已减0.01元</div>
              </div>
            </div>
          </div>
          <div class="paybox paybox-xjk" change-class=" " style="display: none;">
            <div class="p-wrap"><i class="p-border"></i>
              <div class="p-key"><!-- 支付方式选择 --><span class="p-k-check ui-checkbox-wrap ui-check-disable" psa="PCashier_xjk" change-class="ui-check-disable" avalon-events="click:eclick_0_64checkToggle"><i class="ui-checkbox-L"><em change-class=""></em></i><i class="p-k-icon"><img src="//storage.360buyimg.com/payment-assets/sdk/bank/XJKCONSUME.png"></i><strong>京东小金库</strong></span>
                <!-- 支付方式选择 end --></div>
              <div class="p-value">
                <div class="p-v-line xjk-balance"><span class="font-gray">&#8203;</span></div><!--if--></div>
              <div class="p-amount"><em>支付</em><strong>0</strong><em>元</em><!--if--></div>
            </div>
          </div>
        </div>
        <div id="payChanelCompany" class="paychannel-company animate-enter animate-enter-active" avalon-events=""></div>
      </div><!-- paybox 添加新卡网银支付 -->
      <div>
        <div class="paybox-newcard animate-enter animate-enter-active" avalon-events=""><a class="pn-more"
                                                                                           href="javascript:;"
                                                                                           psa="PCashier_home_moreway"
                                                                                           avalon-events="click:eclick_0_64more">更多付款方式<i></i></a><a
          class="pn-new" href="javascript:;" psa="PCashier_home_newcodeorwy"
          avalon-events="click:eclick_0_64showNewCardWangyin4041">添加新卡 / 网银支付</a><a class="pn-multiple"
                                                                                    href="javascript:;"
                                                                                    psa="PCashier_home_multipleway"
                                                                                    avalon-events="click:eclick_0_64multiple"
                                                                                    style="display: none;">分次支付（大额订单）</a>
        </div>
      </div><!-- paybox 添加新卡网银支付 end --><!-- pay-verify 支付验证提交 type-credit type-credit-verify-code -->
      <div>
        <div class="pay-verify animate-enter animate-enter-active" avalon-events="">
          <div class="pv-line" style="display: none;"><input class="ui-input pv-input-cv2" id="pv-input-cvv2"
                                                             type="text" placeholder="信用卡背后3位验证码" maxlength="3"
                                                             autocomplete="off"
                                                             avalon-events="input:_6,compositionstart:_4,compositionend:_5,focus:_2,blur:_3">
          </div>
          <div class="pv-line pv-line-password" style="display: none;">
            <div style="position: absolute;"><input type="password" name="payPwd" placeholder="请输入京东支付密码"
                                                    class="ui-input pv-input-password pv-input-longPassword"
                                                    autocomplete="new-password"
                                                    avalon-events="keypress:ekeypress_0_64switchCase,input:_6,compositionstart:_4,compositionend:_5,focus:_2,blur:_3">
              <div class="tipShow tip_hide" change-class="tip_hide"><span class="squoa"></span>键盘大写已锁定</div>
            </div>
            <span class="font-red ml10"></span><a
            href="//authpay.jd.com/paypwd/showOneModifyPayPwd.action?type=2&amp;active=68" class="ml230" target="_blank"
            psa="PCashier_home_forgetpassword">忘记支付密码？</a></div>
          <div class="pv-line pv-line-shortPwd" style="">
            <div class="pl-s-title">请输入6位数字支付密码</div><!-- 需要错误提示 添加 ui-input-error --><span class="ui-shortPwd" avalon-events="keyup:ekeyup_0_64typeEnter">
            <input type="password" class="ui-shortPwd-input" autocomplete="new-password" maxlength="1" v-for="(item1,index1) in inputList" :key="index1" v-model="item1.val"  @keyup="nextFocus($event,index1)"
                   @keydown="changeValue(index1)"></span>
            <a href="//authpay.jd.com/paypwd/showOneModifyPayPwd.action?type=2&amp;active=68" class="ml10" target="_blank" psa="PCashier_home_forgetpassword">忘记支付密码？</a></div><!-- 支付信息提示 -->
          <div class="pv-msg" style="display: none;">
            <!-- <strong class="font-red">您还差17900.00元，请选择其他支付组合方式。</strong> --><strong class="pv-msg-success"><i
            class="ui-icon ui-icon-success mr5"></i>您的支付密码已经校验通过，请放心支付！</strong></div><!-- 支付信息提示 end --><!-- 支付加载 -->
          <div class="pv-button" style="display: none;"><input class="ui-button ui-button-XL ui-button-XL-loading"
                                                               type="submit" value="加载中"></div>
          <div class="pv-button"><a class="ui-button ui-button-XL" psa="PCashier_home_ljzf"
                                    change-class="ui-button ui-button-XL " @click="pay">立即支付</a><span
            class="font-red ml10"></span></div><!-- <div class="pv-line">
                <a class="pv-agreement" href="">《京东快捷支付相关协议》</a>
            </div> --></div>
      </div><!-- pay-verify 支付验证提交 end --><!-- 新用户引导 old -->
      <div style="display: none;">
        <div class="pay-newUser animate-enter animate-enter-active" avalon-events="">
          <div class="pn-promotion" style="display: none;">首次使用新卡支付<span class="font-red"></span></div>
          <div class="pn-content">
            <div class="pn-c-button"><a class="ui-button ui-button-XL" psa="PCashier_home_newuser_newcard"
                                        avalon-events="click:eclick_0_64showNewCardWangyin404841"><i>+</i>&nbsp;&nbsp;&nbsp;&nbsp;使用新卡支付</a>
            </div>
            <div class="pn-c-ext">
              您还可以&nbsp;<a class="pn-c-text" psa="PCashier_home_newuser_wy"
                           avalon-events="click:eclick_0_64showNewCardWangyin404941">网银支付</a></div>
          </div>
        </div>
      </div><!-- 新用户引导 old end --><!-- 新用户引导 new 营销 -->
      <div style="display: none;">
        <div class="animate-enter animate-enter-active" avalon-events=""><!--unresolved component placeholder--></div>
      </div><!-- 新用户引导 new 营销 end --></div>
    <mcfoot></mcfoot>
  </div>
</template>

<script>
import mcheader from '@/components/Mcheader'
import mcfoot from '@/components/Mcfoot'
import https from './js/https.js'
export default {
  name: 'pay',
  components: {
    mcheader,
    mcfoot
  },
  data () {
    return {
      changeSelectStyle: '',
      bank: [
        {name: '招商银行', imgurl: '//storage.360buyimg.com/payment-assets/sdk/bank/CMB.png'},
        {name: '建设银行', imgurl: '//storage.360buyimg.com/payment-assets/sdk/bank/CCB.png'},
        {name: '中国银行', imgurl: '//storage.360buyimg.com/payment-assets/sdk/bank/BOC.png'}
      ],
      radio: '1',
      inputList: [{val: ''}, {val: ''}, {val: ''}, {val: ''}, {val: ''}, {val: ''}],
      orderInfoId: ''
    }
  },
  methods: {
    changeStyle: function (index) {
      this.changeSelectStyle = index
      console.log(this.changeSelectStyle)
    },

    nextFocus (el, index) {
      var dom = document.getElementsByClassName('ui-shortPwd-input'),
        currInput = dom[index],
        nextInput = dom[index + 1],
        lastInput = dom[index - 1]
      var numReg = /^[0-9]+$/
      if (el.keyCode != 8) {
        if (numReg.test(this.inputList[index].val)) {
          if (index < (this.inputList.length - 1)) {
            nextInput.focus()
          } else {
            currInput.blur()
            console.log('失败')
          }
        } else {
          this.inputList[index].val = ''
        }
      } else {
        if (index != 0) {
          lastInput.focus()
          console.log('退格')
        }
      }
      // 判断是不是整数
      // var numReg = /^[0-9]+$/
      // lastInput = dom[index - 1]
      // if (!numReg.test(this.inputList[index].val)) {
      //   this.inputList[index].val = ''
      // }
    },
    /* 当键盘按下的时候清空原有的数 */
    changeValue (index) {
      this.inputList[index].val = ''
    },
    pay () {
      var userid = sessionStorage.getItem('userId')
      if (userid == null) {
        this.open()
      } else {
        console.log(this.$route.query)
        this.orderInfoId = this.$route.query.orderInfoId
        https.fetchGet('mocalilie/paypal/prepay', {
          userId: userid,
          orderInfoId: this.orderInfoId
        }).then((res) => {
          console.log(res)
          if (res.data.code == 0) {
            window.location.href = res.data.data
          } else {

          }
        })
      }
    },
    open () {
      this.$confirm('当前未登陆，请登陆你的账户', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        showCancelButton: false,
        center: true
      }).then(() => {
        this.$router.push('/login')
      })
    }
  }
}
</script>

<style scoped>
  /* @update: 2018-9-5 17:4:4 */
  @charset "UTF-8";
  a, address, b, big, blockquote, body, center, cite, code, dd, del, div, dl, dt, em, fieldset, font, form, h1, h2, h3, h4, h5, h6, html, i, iframe, img, ins, label, legend, li, ol, p, pre, small, span, strong, u, ul, var {
    margin: 0;
    padding: 0
  }

  ol, ul {
    list-style: none
  }

  :focus {
    outline: 0
  }

  a img {
    border: 0
  }

  img {
    vertical-align: middle
  }

  table {
    empty-cells: show
  }

  ins {
    text-decoration: none
  }

  del {
    text-decoration: line-through
  }

  em {
    font-style: normal
  }

  button::-moz-focus-inner, input[type=button]::-moz-focus-inner, input[type=file] > input[type=button]::-moz-focus-inner, input[type=reset]::-moz-focus-inner, input[type=submit]::-moz-focus-inner {
    border: none;
    padding: 0
  }

  .fl {
    float: left
  }

  .fr {
    float: right
  }

  .fn {
    float: none
  }

  .al {
    text-align: left
  }

  .ac {
    text-align: center
  }

  .ar {
    text-align: right
  }

  .clr {
    display: block;
    overflow: hidden;
    clear: both;
    height: 0;
    line-height: 0;
    font-size: 0
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden
  }

  .clearfix {
    display: inline-table
  }

  .clearfix {
    display: block
  }

  .clearfix {
    *height: 1%;
    *min-height: 1%
  }

  .overflow {
    overflow: hidden
  }

  .m, .mb, .mc, .mt, .sm, .smb, .smc, .smt {
    overflow: hidden;
    zoom: 1
  }

  .m, .sm {
    margin-bottom: 10px
  }

  .mt, .smt {
    cursor: default
  }

  .mt h2, .smt h3 {
    font-family: "microsoft yahei"
  }

  .m .mt .extra a:link, .m .mt .extra a:visited, .sm .smt .extra a:link, .sm .smt .extra a:visited {
    color: #005ea7
  }

  .form .label, .form button, .form input, .form label, .form select, .form textarea {
    float: left;
    font-size: 12px
  }

  body {
    font: 12px/150% Arial, Verdana, "\5b8b\4f53";
    color: #666;
    background: #fff;
    _background-image: url(about:blank);
    _background-attachment: fixed
  }

  h1 {
    font: 20px "microsoft yahei", "\5b8b\4f53"
  }

  h2, h3 {
    font-size: 14px
  }

  h4, h5, h6 {
    font-size: 12px
  }

  a {
    color: #666;
    text-decoration: none
  }

  a:hover {
    color: #e4393c;
    text-decoration: underline
  }

  .w {
    width: 990px;
    margin: 0 auto
  }

  .w1 {
    margin-bottom: 10px
  }

  .root61 .w {
    width: 1210px
  }

  .mt5 {
    margin-top: 5px
  }

  .mt10 {
    margin-top: 10px
  }

  .mt15 {
    margin-top: 15px
  }

  .mt20 {
    margin-top: 20px
  }

  .mt25 {
    margin-top: 25px
  }

  .mb5 {
    margin-bottom: 5px
  }

  .mb10 {
    margin-bottom: 10px
  }

  .mb15 {
    margin-bottom: 15px
  }

  .mb20 {
    margin-bottom: 20px
  }

  .mb30 {
    margin-bottom: 30px
  }

  .ml5 {
    margin-left: 5px
  }

  .ml10 {
    margin-left: 10px
  }

  .ml15 {
    margin-left: 15px
  }

  .ml20 {
    margin-left: 20px
  }

  .ml25 {
    margin-left: 25px
  }

  .ml30 {
    margin-left: 30px
  }

  .ml40 {
    margin-left: 40px
  }

  .mr5 {
    margin-right: 5px
  }

  .mr10 {
    margin-right: 10px
  }

  .mr15 {
    margin-right: 15px
  }

  .mr20 {
    margin-right: 20px
  }

  .p0 {
    padding: 0
  }

  .pt5 {
    padding-top: 5px
  }

  .pt10 {
    padding-top: 10px
  }

  .pt15 {
    padding-top: 15px
  }

  .pt20 {
    padding-top: 20px
  }

  .pb5 {
    padding-bottom: 5px
  }

  .pb10 {
    padding-bottom: 10px
  }

  .pb15 {
    padding-bottom: 15px
  }

  .pb20 {
    padding-bottom: 20px
  }

  .pl5 {
    padding-left: 5px
  }

  .pl10 {
    padding-left: 10px
  }

  .pl15 {
    padding-left: 15px
  }

  .pl20 {
    padding-left: 20px
  }

  .pr5 {
    padding-right: 5px
  }

  .pr10 {
    padding-right: 10px
  }

  .pr15 {
    padding-right: 15px
  }

  .pr20 {
    padding-right: 20px
  }

  .p30 {
    padding: 30px
  }

  .ml40 {
    margin-left: 40px
  }

  .mr40 {
    margin-right: 40px
  }

  .pointer {
    cursor: pointer
  }

  .font-black {
    color: #666
  }

  .font-gray {
    color: #999
  }

  .font-red {
    color: #e31613
  }

  .font-blue {
    color: #67a4ff
  }

  .font-bold {
    font-weight: 700
  }

  .wrap-disable {
    cursor: default;
    opacity: .4
  }

  .font-size-14 {
    font-size: 14px
  }

  .font-size-16 {
    font-size: 16px
  }

  .text-center {
    text-align: center
  }

  .text-left {
    text-align: left
  }

  .text-right {
    text-align: right
  }

  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  a {
    color: #67a4ff
  }

  a:hover {
    text-decoration: none;
    color: #e31613
  }

  .hide {
    display: none
  }

  #no-ie {
    display: none;
    height: 40px;
    line-height: 40px;
    background-color: #63a5fc;
    color: #fff
  }

  #no-ie .w {
    position: relative;
    padding-left: 30px;
    width: 960px
  }

  #no-ie .ni-icon {
    position: absolute;
    width: 20px;
    height: 20px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/ie-icon.png) no-repeat;
    top: 10px;
    left: 0
  }

  #no-ie .ni-close {
    position: absolute;
    width: 20px;
    height: 20px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/ie-close.png) no-repeat;
    right: 5px;
    top: 10px;
    cursor: pointer
  }

  #no-ie a {
    color: #fff;
    font-weight: 700;
    margin: 0 2px
  }

  .shortcut {
    width: 100%;
    height: 50px
  }

  .shortcut .w {
    position: relative;
    height: 50px
  }

  .shortcut .s-right {
    float: right;
    padding-top: 20px
  }

  .shortcut .s-right .s-div {
    float: left;
    color: #ddd
  }

  .shortcut .s-right .s-item {
    height: 20px;
    line-height: 20px;
    padding: 0 11px 0 12px;
    float: left
  }

  .shortcut a {
    color: #666
  }

  .shortcut a:hover {
    color: #e4393c
  }

  .shortcut .s-logo {
    position: absolute;
    left: 0;
    top: 15px
  }

  .p-footer {
    background-color: #fff
  }

  .p-footer .pf-wrap {
    padding: 18px 0;
    border-top: 1px solid #ddd
  }

  .p-footer .pf-line {
    line-height: 20px;
    text-align: center
  }

  .p-footer .pf-line .pf-l-copyright {
    margin-right: 40px
  }

  .main {
    background-color: #fff;
    padding-bottom: 50px
  }

  .promotion {
    background-color: #fff;
    padding-bottom: 50px
  }

  .promotion .p-item {
    padding-bottom: 10px
  }

  #footer-2013 {
    padding-top: 35px
  }

  .ui-checkbox, .ui-checkbox-L {
    display: inline-block;
    width: 24px;
    height: 22px;
    vertical-align: middle
  }

  .ui-checkbox em, .ui-checkbox-L em {
    display: block;
    width: 24px;
    height: 22px;
    background-image: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png);
    background-repeat: no-repeat;
    background-position: -9999px -9999px
  }

  .ui-checkbox-L em {
    background-position: -2px 0
  }

  .changeStyle {
    background-position: -2px -31px
  }

  .ui-checkbox-L.ui-checkbox-L-hover em {
    background-position: -2px -281px
  }

  .ui-checkbox-L.ui-checkbox-L-hover .selected {
    background-position: -2px -31px
  }

  .ui-checkbox {
    width: 14px;
    height: 14px
  }

  .ui-checkbox em {
    width: 14px;
    height: 14px;
    background-position: -42px -2px
  }

  .ui-checkbox .selected {
    background-position: -42px -33px
  }

  .ui-checkbox:hover em {
    background-position: -42px -283px
  }

  .ui-checkbox:hover .selected {
    background-position: -42px -33px
  }

  .ui-checkbox-wrap {
    cursor: pointer
  }

  .ui-checkbox-wrap.ui-check-disable {
    cursor: default;
    opacity: .4
  }

  .ui-radio {
    display: inline-block;
    width: 14px;
    height: 14px;
    vertical-align: middle
  }

  .ui-radio em {
    display: block;
    width: 14px;
    height: 14px;
    background-image: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png);
    background-repeat: no-repeat;
    background-position: -75px -1px
  }

  .ui-radio .selected {
    background-position: -75px -32px
  }

  .ui-radio:hover em {
    background-position: -75px -282px
  }

  .ui-radio:hover .selected {
    background-position: -75px -32px
  }

  .ui-radio-wrap {
    cursor: pointer
  }

  .ui-radio-wrap.ui-check-disable {
    cursor: default;
    opacity: .4
  }

  .ui-input {
    width: 208px;
    height: 20px;
    padding: 5px 10px;
    line-height: 20px;
    font-size: 12px;
    background-color: #fff;
    border: 1px solid #c6c6c6;
    border-radius: 2px;
    box-shadow: 0 1px 1px 1px #ededed inset;
    vertical-align: middle
  }

  .ui-input:focus {
    outline-style: none;
    border-color: #b0c2e1
  }

  .ui-input:hover {
    outline-style: none;
    border-color: #b0c2e1
  }

  .ui-input.ui-input-error {
    border-color: #e31613
  }

  .ui-input.placeholder {
    color: #c7c7c7
  }

  .ui-input::-moz-placeholder {
    color: #c7c7c7
  }

  .ui-input:-ms-input-placeholder {
    color: #c7c7c7
  }

  .ui-input::-webkit-input-placeholder {
    color: #c7c7c7
  }
  .ui-input-sim .ui-input-sim-input {
    height: 20px;
    padding: 0;
    border: 0 none;
    width: 100%
  }
  .ui-input-shortPwd .ui-is-inner {
    position: absolute;
    left: 10px;
    top: 5px;
    width: 244px;
    text-indent: 8px;
    letter-spacing: 32px;
    font-size: 20px;
    line-height: 28px;
    padding: 0;
    height: 28px;
    border: 0 none;
    background: 0 0;
    font-family: Arial;
    font-weight: 700
  }

  .ui-input-shortPwd .ui-is-mask {
    position: absolute;
    display: block;
    cursor: default;
    width: 18px;
    height: 28px;
    top: 5px;
    right: -19px;
    background: #fff
  }

  .ui-shortPwd {
    display: inline-block;
    /*width: 235px;*/
    height: 28px;
    /*padding: 5px 0;*/
    line-height: 20px;
    font-size: 12px;
    background-color: #fff;
    border: 1px solid #c6c6c6;
    border-radius: 2px;
    box-shadow: 0 1px 1px 1px #ededed inset;
    vertical-align: middle;
    overflow: hidden;
    transition: border-color .1s;
    background: #fff url(//storage.360buyimg.com/payment-assets/pc/icon/shortPwd-bg.png) no-repeat center center
  }

  .ui-shortPwd.ui-input-error {
    border-color: #e31613
  }

  .ui-shortPwd .ui-shortPwd-input {
    border: 0 none;
    padding: 0;
    width: 35px;
    height: 28px;
    line-height: 28px;
    float: left;
    background: 0 0;
    margin: 0 2px;
    text-align: center;
    font-size: 16px
  }

  .ui-shortPwd input::-webkit-input-safebox-button {
    display: none
  }

  .ui-icon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png?20150430) no-repeat -9999px -9999px;
    vertical-align: middle
  }

  .ui-icon-success {
    background-position: -82px -441px
  }

  .ui-tab .ui-tab-item a {
    border-radius: 3px 3px 0 0;
    background: #f7f7f7;
    line-height: 34px;
    height: 34px;
    padding: 0 20px;
    border: 1px solid #f7f7f7;
    border-bottom: 0;
    color: #4d4d4d;
    display: inline-block;
    font-size: 14px
  }

  .ui-tab .ui-tab-item a:hover {
    text-decoration: none;
    background: #d8f1ff;
    border-color: #d8f1ff
  }

  .ui-tab .ui-tab-item.curr a {
    background: #fff;
    border-color: #c6c6c6;
    height: 35px;
    font-weight: 700
  }

  .ui-button {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    padding: 0 28px;
    color: #fff;
    border: 1px solid #e31613;
    background: #ff403d;
    background: linear-gradient(#ff403d, #e31613);
    border-radius: 2px;
    vertical-align: middle;
    cursor: pointer;
    text-align: center;
    text-shadow: 0 1px 2px rgba(0, 0, 0, .2);
    box-shadow: 0 1px 0 0 #fe8c8a inset
  }

  .ui-button:hover {
    background: linear-gradient(#ff5e5b, #ff4644);
    border-color: #ff4644
  }

  .ui-button.disable:hover {
    filter: none;
    background: #b5b5b5;
    border-color: #b5b5b5
  }

  a.ui-button {
    height: 30px;
    line-height: 30px
  }

  a.ui-button:hover {
    color: #fff;
    text-decoration: none
  }

  .ui-button-XL {
    height: 50px;
    line-height: 48px;
    padding: 0;
    font-size: 18px;
    width: 220px;
    font-family: "Microsoft Yahei";
    font-weight: 700;
    text-shadow: 0 1px 2px rgba(0, 0, 0, .3)
  }

  .ui-button-XL.w300 {
    width: 300px
  }

  a.ui-button-XL {
    height: 48px;
    line-height: 48px
  }

  .ui-button-XL-loading {
    background: #fff url(//storage.360buyimg.com/payment-assets/pc/icon/ui-button-XL-loading.gif) center center;
    filter: none;
    box-shadow: none;
    text-shadow: none;
    cursor: default;
    line-height: 2000px;
    overflow: hidden
  }

  .ui-button-XL-loading:hover {
    background: #fff url(//storage.360buyimg.com/payment-assets/pc/icon/ui-button-XL-loading.gif) center center;
    filter: none;
    box-shadow: none;
    text-shadow: none
  }

  a.ui-button-XL-loading {
    line-height: 142px
  }

  .ui-form .ui-form-group p {
    margin-top: 0;
    margin-bottom: 0
  }

  .wrap-revise .ui-form .ui-form-group p {
    margin-top: 0;
    margin-bottom: 0
  }

  .payment-list .pl-item .pl-i-info i {
    font-style: normal;
    padding: 0 4px
  }
 .payment-list .pl-item.bank-disable .bank-logo, .payment-list .pl-item.bank-disable img {
    opacity: .3
  }

  .payment-list .pl-item:hover {
    border-color: #e31613;
    z-index: 20
  }

  .bank-selected em {
    float: left
  }

  .bank-selected .p-div {
    float: left;
    margin: 0 5px;
    color: #999
  }

  .ui-tips.ui-tips-red .ui-tips-wrap a {
    color: #fff
  }

  .ui-tips.ui-tips-red .ui-tips-wrap a:hover {
    text-decoration: underline
  }

  .ui-pop .ui-pop-content table {
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
    width: 100%
  }

  .ui-pop .ui-pop-content table td, .ui-pop .ui-pop-content table th {
    padding: 0;
    line-height: 32px;
    text-align: left;
    padding-left: 20px
  }

  .ui-pop .ui-pop-content table th {
    background-color: #f7f7f7;
    font-weight: 400
  }

  .ui-pop .ui-pop-content table .tr-baitiao td {
    color: #69cd8e;
    border-bottom: 1px solid #ddd
  }

  .ui-pop-paid .ui-pop-title b {
    color: #e31613
  }

  .feedback a {
    display: inline-block;
    width: 57px;
    height: 150px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/wenjuan.png) no-repeat
  }

  .ui-autocomplete .ui-autocomplete-list li {
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    padding-left: 8px;
    padding-right: 8px;
    text-align: left
  }

  .ui-autocomplete .ui-autocomplete-list li:hover {
    background: #f0faff
  }

  .global-main .global-tit b {
    font-size: 18px;
    margin-right: 20px;
    font-family: "microsoft Yahei"
  }

  .side-btn b {
    width: 100%;
    height: 100%;
    display: block
  }

  .side-btn a {
    width: 38px;
    height: 38px;
    display: block;
    position: relative;
    overflow: hidden;
    border-radius: 3px;
    margin: 3px 0
  }

  .side-btn a span {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: all .15s ease-in-out
  }

  .side-btn a:hover span {
    top: -38px
  }

  .side-bar .side-tab li {
    width: 120px;
    border-bottom: 3px solid transparent;
    font-size: 16px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    font-weight: 700;
    float: left;
    margin: 0 10px;
    cursor: pointer
  }

  .side-bar .side-tab li.active {
    border-bottom: 3px solid #fb6d6b;
    cursor: default;
    color: #fb6d6b
  }

  .side-bar .qa-list li {
    border-bottom: 1px solid #dfe2ea;
    margin: 0 10px;
    position: relative
  }

  .side-bar .qa-list li .qa-item {
    line-height: 19px;
    display: block;
    width: 85%;
    margin: 0 10px;
    cursor: pointer;
    padding: 10px 0
  }

  .side-bar .qa-list li i {
    width: 8px;
    height: 4px;
    position: absolute;
    right: 10px;
    top: 18px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/qa-icon.png) no-repeat
  }

  .side-bar .jimi-btn span {
    font-size: 20px;
    vertical-align: bottom
  }

  html {
    background: #fff;
    overflow-y: scroll
  }

  .paybox {
    border-bottom: 1px solid #eee;
    padding: 0 2px 1px 2px
  }

  .paybox .p-wrap {
    position: relative;
    _zoom: 1;
    padding-top: 10px;
    padding-bottom: 10px
  }

  .paybox .p-key {
    float: left;
    padding-top: 5px;
    padding-left: 18px
  }

  .paybox .p-key .p-k-check {
    display: inline-block;
    line-height: 22px;
    cursor: pointer
  }

  .paybox .p-key .p-k-check .ui-checkbox-L {
    vertical-align: top
  }

  .paybox .p-key .p-k-check .p-k-icon {
    vertical-align: top;
    display: inline-block;
    margin-left: 30px;
    margin-top: -2px;
    width: 26px;
    height: 26px
  }

  .paybox .p-key .p-k-check .p-k-icon img {
    width: 26px;
    height: 26px
  }

  .paybox .p-key .p-k-check strong {
    color: #333;
    vertical-align: top;
    display: inline-block;
    margin-left: 8px;
    font-size: 16px;
    font-family: "Microsoft Yahei"
  }

  .paybox .p-key .p-k-check.ui-check-disable {
    cursor: default
  }

  .paybox .p-key .p-k-check:hover strong {
    color: #666
  }

  .paybox .p-key .p-k-check-baitiao strong {
    height: 23px;
    padding-right: 50px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png) no-repeat 35px -248px
  }

  .paybox .p-value {
    margin-left: 225px;
    margin-right: 5px;
    _position: relative;
    _zoom: 1
  }

  .paybox .p-value .p-v-line {
    line-height: 32px
  }

  .paybox .p-div {
    margin: 0 8px;
    color: #ddd
  }

  .paybox .p-amount {
    display: none;
    position: absolute;
    width: 140px;
    right: 18px;
    top: 14px;
    text-align: right;
    line-height: 26px
  }

  .paybox .p-amount em {
    vertical-align: bottom
  }

  .paybox .p-amount strong {
    font-size: 18px;
    vertical-align: bottom;
    color: #e31613;
    margin: 0 3px
  }

  .paybox .p-amount .pre-val {
    color: #b0b0b0
  }

  .paybox .p-border {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    left: -2px;
    top: -2px;
    border: 2px solid #b0c2e1
  }

  .paybox.paybox-selected .p-amount {
    display: block
  }

  .paybox.paybox-selected .bb-coupo {
    position: relative;
    z-index: 89;
    cursor: pointer
  }

  .paybox.paybox-selected .bb-coupo .bb-coupo-icon {
    background-color: #e31613;
    color: #fff;
    border: 1px solid #e31613
  }

  .paybox.paybox-selected .bb-coupo .bb-coupo-text {
    color: #e31613;
    width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  .paybox.paybox-selected .bb-coupo .bb-coupo-text i {
    display: inline-block;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png) no-repeat -79px -226px
  }

  .paybox.paybox-selected.paybox-couponselect {
    min-height: 70px
  }

  .paybox-baitiao .p-amount {
    width: 180px
  }

  .paybox-baitiao .p-key .p-k-check .p-k-icon {
    margin-top: -4px
  }

  .paybox-baitiao .p-key .p-k-check .p-k-icon img {
    width: 24px;
    height: 30px
  }

  .paybox-gb .p-key .p-k-check .p-k-icon, .paybox-jdbalance .p-key .p-k-check .p-k-icon, .paybox-jingbean .p-key .p-k-check .p-k-icon, .paybox-qbb .p-key .p-k-check .p-k-icon {
    display: none
  }

  .paybox-gb .p-key .p-k-check strong, .paybox-jdbalance .p-key .p-k-check strong, .paybox-jingbean .p-key .p-k-check strong, .paybox-qbb .p-key .p-k-check strong {
    margin-left: 32px
  }

  .baitiao-balance {
    _height: 32px
  }

  .baitiao-balance .bb-coupo {
    cursor: default
  }

  .baitiao-balance .bb-coupo .bb-coupo-icon {
    display: inline-block;
    height: 16px;
    line-height: 16px;
    background-color: #fff;
    color: #e31613;
    border: 1px solid #e31613;
    padding: 0 4px;
    font-style: normal;
    border-radius: 3px;
    margin-right: 3px
  }

  .baitiao-balance .bb-coupo .bb-coupo-text {
    color: #e31613
  }

  .baitiao-balance .bb-coupo .bb-coupo-text b {
    font-weight: 400
  }

  .baitiao-balance .bb-coupo .bb-coupo-text i {
    display: none;
    vertical-align: middle;
    margin-left: 3px;
    width: 6px;
    height: 3px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png) no-repeat -79px -226px;
    overflow: hidden;
    text-indent: -2em
  }

  .jincai-banlance .bb-coupo, .xjk-balance .bb-coupo {
    cursor: default
  }

  .jincai-banlance .bb-coupo .bb-coupo-icon, .xjk-balance .bb-coupo .bb-coupo-icon {
    display: inline-block;
    height: 18px;
    line-height: 18px;
    background-color: #fff;
    color: #e31613;
    border: 1px solid #e31613;
    padding: 0 4px;
    font-style: normal;
    border-radius: 3px;
    margin-right: 3px
  }

  .jincai-banlance .bb-coupo .bb-coupo-text, .xjk-balance .bb-coupo .bb-coupo-text {
    color: #e31613
  }

  .jincai-banlance .bb-coupo .bb-coupo-text b, .xjk-balance .bb-coupo .bb-coupo-text b {
    font-weight: 400
  }

  .jincai-banlance .bb-coupo .bb-coupo-text i, .xjk-balance .bb-coupo .bb-coupo-text i {
    display: none;
    vertical-align: middle;
    margin-left: 3px;
    width: 6px;
    height: 3px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png) no-repeat -79px -80px;
    overflow: hidden;
    text-indent: -2em;
    *margin-top: -8px
  }

  .baitiao-choose .pl-item.disable .pl-i-fenqi, .baitiao-choose .pl-item.disable .pl-i-text {
    color: #adadad
  }

  .otheramount-list li {
    line-height: 28px;
    _height: 28px
  }

  .bank-identific .ui-button {
    color: #fff
  }

  .pay-more a {
    line-height: 20px;
    height: 20px;
    display: inline-block;
    padding-right: 15px;
    position: relative
  }

  .pay-more a i {
    right: 0;
    top: 3px;
    position: absolute;
    display: block;
    width: 12px;
    height: 12px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png) no-repeat -76px -75px
  }

  .pay-more a:hover i {
    background-position: -76px -221px
  }

  .pay-verify {
    padding-left: 76px;
    padding-top: 32px;
    padding-bottom: 20px
  }

  .pay-verify .pv-line {
    line-height: 32px;
    margin-bottom: 10px
  }

  .pay-verify .pv-line.pv-line-shortPwd .pl-s-title {
    color: #999;
    line-height: 20px;
    margin-bottom: 5px
  }

  .pay-verify .pv-input-cv2 {
    width: 130px
  }

  .pay-verify .pv-msg {
    line-height: 20px;
    margin-bottom: 10px
  }

  .pay-verify .pv-msg .pv-msg-success {
    color: #999;
    font-weight: 400
  }
  .payment-change-wangyin .pc-wangyin .pc-w-describe, .payment-change-wangyin .pc-wangyin .pc-w-icon, .payment-change-wangyin .pc-wangyin .ui-icon-new, .payment-change-wangyin .pc-wangyin .ui-icon-recommend {
    float: left;
    cursor: pointer
  }

  .payment-change-wangyin .pc-wangyin .pc-w-price {
    float: right;
    cursor: pointer
  }

  .payment-change-wangyin .pc-wangyin .pc-w-icon {
    margin-top: 19px;
    width: 88px;
    height: 18px;
    background-image: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png);
    background-repeat: no-repeat;
    background-position: -2px -578px
  }

  .payment-change-wangyin .pc-wangyin .ui-icon-new, .payment-change-wangyin .pc-wangyin .ui-icon-recommend {
    margin-top: 19px;
    margin-left: 5px;
    margin-right: 10px
  }

  .payment-change-wangyin .pc-wangyin .pc-w-price {
    display: none;
    color: #666;
    height: 56px;
    margin-right: 20px;
    margin-left: 20px
  }

  .payment-change-wangyin .pc-wangyin .pc-w-price strong {
    float: none;
    margin-right: 0;
    color: #e31613;
    font-size: 18px;
    cursor: pointer
  }

  .payment-change-wangyin .pc-wangyin .ui-button {
    margin-top: 11px;
    float: right
  }

  .payment-change-wangyin .pc-wangyin:hover .pc-w-price {
    display: block
  }

  .op-tab-content {
    padding: 15px 20px 20px 20px
  }

  .op-tab-content .op-info {
    line-height: 32px;
    margin-bottom: 10px
  }

  .op-tab-content .op-info .op-i-text {
    color: #999;
    float: left
  }

  .op-tab-content .op-info .op-i-ext {
    float: right
  }

  .op-tab-content .op-phoneverify {
    line-height: 32px
  }

  .op-tab-content .op-phoneverify .ui-input {
    width: 120px
  }

  .op-tab-content .op-title {
    font-weight: 700;
    line-height: 32px
  }

  .op-tab-content .op-title .op-t-ext {
    color: #999;
    font-weight: 400;
    margin-left: 5px
  }

  .op-tab-content .op-hr {
    height: 0;
    padding-top: 10px;
    margin-bottom: 20px;
    font-size: 0;
    border-bottom: 1px dashed #e1e1e1
  }

  .op-tab-content .op-line {
    line-height: 32px
  }

  .op-tab-content .op-confirm {
    line-height: 50px
  }

  .op-tab-content .op-article h5 {
    line-height: 32px
  }

  .op-tab-content .op-article p {
    line-height: 22px
  }

  .op-tab-content .op-a-form {
    padding: 10px;
    background: #f7f7f7
  }

  .op-tab-content .op-result {
    font-size: 14px;
    font-weight: 700
  }

  .op-tab-content .op-result .op-r-send {
    font-size: 12px;
    font-weight: 400
  }

  .op-tab-content .op-error {
    font-size: 12px;
    color: #e31613;
    font-weight: 400;
    padding: 0 5px
  }

  .op-type-platform .payment-list {
    width: 890px
  }

  .op-type-platform .pl-wrap {
    width: 910px
  }

  .op-type-platform .pl-item {
    width: 168px
  }

  .op-type-platform .pl-item .pay-logo {
    margin-left: 15px
  }

  .op-type-postoffice {
    padding-bottom: 60px
  }

  .op-type-enterprise .payment-list {
    padding-left: 20px
  }

  .op-type-enterprise .op-enterprise-result {
    padding-left: 20px
  }

  .op-type-enterprise .op-confirm, .op-type-enterprise .op-line {
    padding-left: 20px
  }

  .payment-company {
    padding-top: 40px;
    padding-bottom: 20px
  }

  .payment-prepaid {
    padding-bottom: 40px
  }

  .payment-prepaid .pp-title {
    padding-left: 25px;
    padding-top: 20px;
    margin-bottom: 30px;
    font-size: 14px;
    font-weight: 700
  }

  .payment-prepaid .payment-list {
    padding-left: 25px
  }

  .payment-prepaid .payment-list .pl-item {
    padding: 0;
    height: 44px;
    width: 198px
  }

  .cashier-notice {
    height: 36px;
    padding: 0 30px;
    background-color: #4b5b78;
    overflow: hidden
  }

  .cashier-notice .cn-content {
    float: left;
    font-size: 14px;
    line-height: 40px
  }

  .cashier-notice .cn-content strong {
    color: #fff
  }

  .cashier-notice .cn-content span {
    color: #c9ced7
  }

  .cashier-notice .cn-close {
    margin-top: 11px;
    float: right;
    display: block;
    width: 16px;
    height: 16px;
    cursor: pointer;
    text-indent: -9990px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png) no-repeat -2px -143px
  }

  .p-w-bd, .pay-weixin {
    zoom: 1
  }

  .p-w-bd:after, .pay-weixin:after {
    display: table;
    content: "";
    clear: both
  }

  .p-w-hd {
    margin-bottom: 20px;
    font-size: 18px;
    font-family: "Microsoft Yahei"
  }

  .p-w-bd {
    padding-left: 130px;
    margin-bottom: 30px
  }

  .p-w-box {
    float: left;
    width: 300px
  }

  .p-w-sidebar {
    float: left;
    width: 379px;
    height: 421px;
    padding-left: 50px;
    margin-top: -20px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/phone-bg.png) 50px 0 no-repeat
  }

  .pw-box-hd {
    margin-bottom: 20px;
    border: 1px solid #ddd;
    width: 298px;
    height: 298px
  }

  .pw-box-hd img {
    width: 298px;
    height: 298px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/ui-modal-loading.gif) center center no-repeat
  }

  .pw-box-ft {
    height: 44px;
    padding: 8px 0 8px 125px;
    background: #ff7674 url(//storage.360buyimg.com/payment-assets/pc/icon/icon-red.png) 50px 8px no-repeat
  }

  .pw-box-ft p {
    margin: 0;
    font-size: 14px;
    line-height: 22px;
    color: #fff;
    font-weight: 700
  }

  .pw-retry {
    display: none;
    position: absolute;
    width: 300px;
    height: 300px;
    left: 130px;
    top: 0;
    background: rgba(0, 0, 0, .4);
    overflow: hidden;
    text-align: center
  }

  .pw-retry .ui-button {
    margin-top: 135px
  }

  .pay-pop-outer {
    width: 665px;
    top: 275px;
    margin-left: -340px
  }

  .wangyin-modal {
    width: 650px;
    left: 50%;
    margin-left: -325px
  }

  .wangyin-modal-success {
    width: 480px;
    left: 50%;
    margin-left: -240px
  }

  .wangyin-payed a {
    color: #2fa1dd;
    text-decoration: none
  }

  .wangyin-payed .p-tips1 {
    font-size: 14px;
    margin-bottom: 30px
  }

  .wangyin-payed .b-info {
    display: inline-block;
    width: 80px;
    padding-left: 10px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/pay-dotted.png) left center no-repeat;
    font-size: 14px
  }

  .wangyin-payed .fast-bank {
    cursor: pointer;
    overflow: hidden;
    display: inline-block;
    width: 182px;
    height: 30px;
    margin: 0 5px -12px 10px;
    padding-right: 10px;
    padding-left: 5px;
    border: 1px solid #b0c2e1;
    line-height: 30px;
    text-align: right;
    transition: border-color .2s
  }

  .wangyin-payed .fast-bank .bank-logo {
    float: left
  }

  .wangyin-payed .fast-bank:hover {
    border-color: #e31613
  }

  .wangyin-payed .payError a {
    padding: 0 10px
  }

  .wangyin-payed .payError a.border {
    border-right: 1px solid #ddd
  }

  .wangyin-payed .qrcode-box {
    margin-top: 35px;
    padding-top: 25px;
    border-top: 1px dotted #ddd
  }

  .wangyin-payed .qrcode-img {
    float: left;
    width: 70px;
    height: 70px;
    margin-right: 20px
  }

  .wangyin-payed .qrcode-tips {
    padding-top: 5px;
    margin-bottom: 15px;
    font-size: 14px
  }

  .wangyin-payed .qrcode-tips a {
    margin-left: 20px;
    font-size: 12px;
    color: #2fa1dd;
    text-decoration: none
  }

  .wangyin-payed .qrcode-icon a {
    display: inline-block;
    width: 97px;
    height: 29px
  }

  .wangyin-payed .qrcode-icon a.p-app {
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/pay-appIcon.png) no-repeat;
    margin-right: 10px
  }

  .wangyin-payed .qrcode-icon a.p-and {
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/pay-andIcon.png) no-repeat
  }

  .wangyin-payed .pay-ilist li {
    overflow: hidden;
    height: 14px;
    padding: 20px 0;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/p-dashed.png) 0 53px repeat-x
  }

  .wangyin-payed .pay-ilist li .p-name {
    float: left;
    width: 100px;
    padding-left: 10px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/pay-dotted.png) 2px center no-repeat;
    font-weight: 700;
    font-size: 14px
  }

  .wangyin-payed .pay-ilist li .p-money {
    float: left;
    width: 140px;
    font-size: 12px;
    font-family: "Microsoft Yahei"
  }

  .wangyin-payed .pay-ilist li .p-flag {
    padding-left: 20px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/p-info.png) no-repeat;
    font-size: 12px
  }

  .wangyin-payed .pay-ilist li .p-success {
    background-position: 0 0;
    color: #4fd215
  }

  .wangyin-payed .pay-ilist li .p-failure {
    background-position: 0 -16px;
    color: #ff7674
  }

  .wangyin-payed .pay-count {
    padding: 20px 0 20px 15px;
    font-size: 14px;
    font-weight: 700;
    color: #ff7674
  }

  .wangyin-payed .pay-lbtn {
    color: #999
  }

  .wangyin-payed .pay-lbtn a.ui-button {
    color: #fff;
    margin-right: 20px
  }

  .wangyin-payed-success .wps-button {
    text-align: center;
    margin-bottom: 30px
  }

  .wangyin-payed-success .wps-other {
    padding-top: 30px;
    border-top: 1px solid #ddd;
    overflow: hidden;
    zoom: 1
  }

  .wangyin-payed-success .wps-other .wps-o-line {
    line-height: 32px
  }

  .wangyin-payed-success .wps-other .wps-o-left, .wangyin-payed-success .wps-other .wps-o-right {
    float: left
  }

  .wangyin-payed-success .wps-other .wps-o-left {
    padding-right: 25px
  }

  .wangyin-payed-success .wps-other .wps-o-bank {
    display: inline-block;
    padding: 0 15px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    border: 1px solid #b0c2e1;
    border-radius: 2px;
    font-weight: 700;
    margin-left: 10px;
    color: #666
  }

  .wangyin-payed-success .wps-other .wps-o-bank:hover {
    border-color: #e31613
  }

  .wangyin-payed-success .wps-other .wps-o-qrcode {
    padding-left: 25px;
    border-left: 1px dashed #ddd;
    width: 96px
  }

  .wangyin-payed-success .wps-other .wps-o-qrcode .wps-o-qrcode-img {
    width: 71px;
    height: 46px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/result-modal-qrcode.png) no-repeat
  }

  .wangyin-payed-success .wps-other .wps-o-qrcode .wps-o-qrcode-text {
    margin-top: 4px;
    height: 18px;
    overflow: hidden;
    line-height: 18px
  }

  .wangyin-payed-success .wps-bottom {
    padding-top: 20px;
    border-top: 1px dashed #ddd;
    line-height: 32px
  }

  .wangyin-payed-success .wps-bottom .p-div {
    margin: 0 3px;
    color: #ddd
  }

  .wangyin-payed-success .wps-bottom .wps-b-bank {
    display: inline-block;
    padding: 0 15px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    border: 1px solid #b0c2e1;
    border-radius: 2px;
    font-weight: 700;
    margin-left: 10px
  }

  .verification-modal {
    width: 440px;
    left: 50%;
    margin-left: -220px
  }

  .verification-modal .ui-modal-content {
    padding-bottom: 10px
  }

  .verification-modal .um-h-title span {
    font-size: 12px;
    font-family: "\5b8b\4f53"
  }

  .verification-content .vc-amount {
    text-align: center;
    font-size: 24px;
    font-family: "Microsoft Yahei";
    line-height: 26px;
    margin-bottom: 20px
  }

  .verification-content .vc-amount .vc-a-phone {
    font-size: 12px
  }

  .verification-content .vc-amount.newAmount {
    font-size: 16px;
    text-align: left;
    color: #323232
  }

  .verification-content .vc-amount.newAmount .fs20 {
    font-size: 20px;
    text-align: center
  }

  .verification-content .vc-buttons {
    margin-bottom: 10px;
    height: 40px
  }

  .verification-content .vc-buttons:before {
    content: '';
    height: 0;
    display: block;
    clear: both
  }

  .verification-content .vc-buttons > div {
    height: 40px;
    width: 145px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    border-radius: 4px
  }

  .verification-content .vc-buttons > div.repay {
    background: #f52f3e;
    color: #fff;
    margin: 0 auto
  }

  .verification-content .vc-number {
    text-align: center;
    position: relative;
    height: 90px
  }

  .verification-content .vc-number .vc-n-grid {
    vertical-align: top;
    height: 48px;
    font-size: 0;
    display: inline-block;
    border: 1px solid #c6c6c6;
    border-radius: 2px;
    box-shadow: 0 1px 1px 1px #ededed inset
  }

  .verification-content .vc-number .vc-n-grid .grid-item {
    vertical-align: top;
    display: inline-block;
    width: 48px;
    height: 48px
  }

  .verification-content .vc-number .vc-n-input {
    position: absolute;
    border: 0 none;
    background: 0 0;
    top: 0;
    left: 50%;
    margin-left: -130px;
    width: 295px;
    height: 48px;
    line-height: 48px;
    font-size: 30px;
    letter-spacing: 32px
  }

  .verification-content .vc-number .vc-n-block {
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: 150px;
    width: 48px;
    height: 48px;
    background: #fff
  }

  .verification-content .vc-n-error {
    display: none;
    margin-top: 8px;
    line-height: 20px;
    color: #e31613
  }

  .verification-content .vc-operations {
    border-top: 1px solid #c6c6c6;
    padding-top: 10px
  }

  .verification-content .vc-operations .disable {
    cursor: default;
    border-color: #fff;
    background-color: #fff
  }

  .verification-content .vc-operations .vc-o-left {
    display: inline-block;
    width: 240px;
    text-align: center
  }

  .verification-content .vc-operations .vc-o-right {
    display: inline-block;
    width: 100px;
    text-align: center;
    height: 20px;
    line-height: 20px;
    border-left: 1px solid #c6c6c6
  }

  .verification-content .vc-operations .vc-close {
    color: #666
  }

  .verification-content .vc-operations .vc-operations-link {
    text-align: center;
    line-height: 32px
  }

  .verification-content .vc-operations .vc-operations-link a {
    color: #666
  }

  .verification-content .vc-number.vc-error .vc-n-grid {
    border-color: #e31613
  }

  .verification-content .vc-number.vc-error .vc-n-grid .grid-item {
    border-color: #e31613
  }

  .verification-content .vc-number.vc-error .vc-n-input {
    color: #e31613
  }

  .verification-content .vc-number.vc-error .vc-n-error {
    display: block
  }

  .verification-content .vc-number.vc-loading {
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/ui-button-XL-loading.gif) no-repeat center 8px
  }

  .verification-content .vc-number.vc-loading .vc-n-block, .verification-content .vc-number.vc-loading .vc-n-grid, .verification-content .vc-number.vc-loading .vc-n-input {
    display: none
  }

  .baitiaoCoupo-content .baitiaoCoupo-list .bl-item .ui-check-disable {
    filter: none;
    opacity: 1
  }

  .baitiaoCoupo-content .baitiaoCoupo-button {
    text-align: center;
    padding-top: 15px
  }

  .userDeclare-modal .ui-modal-content {
    padding-top: 20px
  }

  .userDeclare-modal .um-tips {
    color: #888;
    line-height: 18px;
    margin-bottom: 20px
  }

  .userDeclare-modal .ui-form {
    padding-left: 6px
  }

  .userDeclare-modal .um-button {
    text-align: center
  }

  .userDeclare-modal .um-button .um-button-error {
    display: block;
    margin-top: 10px;
    color: #e31613;
    line-height: 18px
  }

  .userDeclare-modal .um-form-error {
    color: #e31613
  }

  .jp-logo-wrap {
    position: relative
  }

  .jp-logo-wrap .jp-logo {
    width: 102px;
    height: 35px;
    position: absolute;
    left: -34px;
    top: 0;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/title-jdpay.png) no-repeat
  }

  .jp-notice {
    height: 32px;
    line-height: 32px;
    margin-left: 88px;
    margin-bottom: 15px;
    color: #4b5b78
  }

  .jp-notice .jn-wrap {
    height: 32px;
    overflow: hidden;
    float: right;
    width: 620px;
    position: relative
  }

  .jp-notice .jn-list {
    position: absolute;
    width: 100%;
    top: 0;
    opacity: .6
  }

  .jp-notice .jn-list li {
    width: 100%;
    text-align: right
  }

  .jp-notice .jn-list li span {
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/jn-icon.png) no-repeat left center;
    padding-left: 18px
  }

  .jp-notice .jp-tips {
    float: left;
    color: #999;
    opacity: .8
  }

  .payment-change .pay-other {
    display: none
  }

  .pay-load {
    position: relative;
    min-height: 480px
  }

  .pay-load.pay-load-change {
    position: static;
    min-height: 110px
  }

  .pay-load .pay-loading {
    position: absolute;
    width: 888px;
    height: 350px;
    background: #fff url(//storage.360buyimg.com/payment-assets/pc/icon/pay-loading.gif?20170526) no-repeat;
    left: 50px;
    top: 77px
  }

  .pay-load .pay-channel, .pay-load .pay-more, .pay-load .pay-newUser, .pay-load .pay-verify, .pay-load .paybox-newcard, .pay-load .pc-wrap {
    display: none
  }

  .pay-load .animate-enter, .pay-load .animate-leave {
    display: block;
    opacity: 0;
    transition: all .2s ease-in-out
  }

  .pay-load .animate-enter-active, .pay-load .animate-leave {
    opacity: 1
  }

  .pay-load .animate-leave-active {
    opacity: 0
  }

  .pay-newUser {
    position: relative
  }

  .pay-newUser .pn-promotion {
    position: absolute;
    width: 600px;
    height: 30px;
    line-height: 30px;
    top: 85px;
    left: 50%;
    margin-left: -300px;
    text-align: center;
    font-size: 24px;
    font-family: "Microsoft Yahei";
    color: #666
  }

  .pay-newUser .pn-promotion span {
    margin: 0 10px
  }

  .pay-newUser .pn-content {
    position: absolute;
    width: 600px;
    height: 200px;
    top: 140px;
    left: 50%;
    margin-left: -300px;
    text-align: center
  }

  .pay-newUser .pn-content .pn-c-button {
    margin-bottom: 5px
  }

  .pay-newUser .pn-content .pn-c-button .ui-button {
    position: relative
  }

  .pay-newUser .pn-content .pn-c-button .ui-button i {
    position: absolute;
    left: 40px;
    top: 8px;
    vertical-align: middle;
    font-style: normal;
    font-size: 30px;
    height: 30px;
    line-height: 30px
  }

  .pay-newUser .pn-content .pn-c-ext {
    line-height: 20px
  }

  .pay-newUser .pn-content .pn-c-ext a {
    cursor: text
  }

  .pay-newUserPromotion .pn-title {
    text-align: center;
    font-size: 30px;
    line-height: 46px;
    font-family: "Microsoft Yahei";
    color: #000
  }

  .pay-newUserPromotion .pn-bank-input .bank-input-box {
    width: 435px;
    height: 32px;
    line-height: 32px;
    margin: 50px auto
  }

  .pay-newUserPromotion .pn-bank-input .bank-input-box .label-left {
    margin-right: 10px;
    font-size: 12px;
    color: #333
  }

  .pay-newUserPromotion .pn-bank-input .bank-input-box .input-wrap {
    position: relative;
    border: 1px solid #c6c6c6;
    box-sizing: border-box;
    height: 32px
  }

  .pay-newUserPromotion .pn-bank-input .bank-input-box .input-wrap:before {
    content: '';
    display: inline-block;
    position: absolute;
    width: 14px;
    height: 14px;
    background: url(//img30.360buyimg.com/jr_image/jfs/t14704/162/2148626400/150/fc4336da/5a6fd1ceN7acb2df8.png) no-repeat;
    background-size: 14px 14px;
    top: 50%;
    margin-top: -7px;
    margin-left: 11px
  }

  .pay-newUserPromotion .pn-bank-input .bank-input-box .input-wrap input {
    display: inline-block;
    width: 180px;
    float: left;
    border: none;
    height: 28px;
    padding-left: 34px;
    width: 200px;
    padding-right: 60px
  }

  .pay-newUserPromotion .pn-bank-input .bank-input-box .input-wrap .bankTip {
    position: absolute;
    right: 91px;
    color: #c6c6c6
  }

  .pay-newUserPromotion .pn-bank-input .bank-input-box .input-wrap .nextStep {
    float: left;
    width: 80px;
    height: 30px;
    text-align: center;
    background: #f4a2a1;
    color: #fff;
    cursor: pointer
  }

  .pay-newUserPromotion .pn-bank-input .bank-input-box .input-wrap .nextStep.active {
    background: #e31613
  }

  .pay-newUserPromotion .pn-bank-input .bank-input-box .input-wrap .warning {
    color: #e31613
  }

  .pay-newUserPromotion .pn-promotionText {
    text-align: center;
    font-size: 16px;
    line-height: 26px;
    font-family: "Microsoft Yahei";
    color: #e31613;
    margin-bottom: 30px
  }

  .pay-newUserPromotion .pn-promotionText span {
    padding: 0 10px
  }

  .pay-newUserPromotion .pn-promotionText .pn-p-anquan {
    position: relative
  }

  .pay-newUserPromotion .pn-promotionText .pn-p-anquan i {
    position: absolute;
    right: -4px;
    top: 4px;
    display: block;
    width: 12px;
    height: 14px;
    background: url(//storage.jd.com/payment-assets/pc/icon/newUser-shield.png) no-repeat
  }

  .pay-newUserPromotion .pn-order {
    margin: 0 0 15px 0;
    padding-left: 13px
  }

  .pay-newUserPromotion .pn-order a {
    margin-right: 15px;
    padding: 5px;
    color: #999;
    cursor: pointer
  }

  .pay-newUserPromotion .pn-order a.active, .pay-newUserPromotion .pn-order a:hover {
    color: #67a4ff
  }

  .pay-newUserPromotion .pn-bank .pn-bank-wrap {
    padding-left: 13px
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item {
    position: relative;
    width: 218px;
    height: 80px;
    border: 1px solid #efefef;
    float: left;
    margin-right: 8px;
    margin-bottom: 8px;
    transition: all .2s ease-in-out;
    cursor: pointer
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item .bank-logo {
    position: absolute;
    top: 26px;
    left: 10px
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item .card-type {
    position: absolute;
    top: 26px;
    left: 140px;
    display: block;
    height: 28px;
    line-height: 28px;
    padding-left: 10px;
    border-left: 1px solid #efefef
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item .bank-text {
    display: none
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item.pn-bank-item-promotion .bank-logo {
    top: 14px
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item.pn-bank-item-promotion .card-type {
    top: 14px
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item.pn-bank-item-promotion .bank-text {
    display: block;
    position: absolute;
    bottom: -1px;
    left: -1px;
    width: 204px;
    height: 28px;
    line-height: 28px;
    color: #fff;
    background: url(//storage.jd.com/payment-assets/pc/icon/newUser-bank-linebg.png) no-repeat;
    overflow: hidden;
    font-style: italic;
    font-family: "Microsoft Yahei"
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item.pn-bank-item-promotion .bank-text .bt-info {
    margin-left: 15px;
    margin-right: 5px;
    opacity: .8
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item.pn-bank-item-promotion .bank-text .bt-original {
    margin-right: 10px;
    text-decoration: line-through;
    opacity: .8
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item.pn-bank-item-promotion .bank-text .bt-new {
    font-weight: 700
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item:hover {
    border-color: #fff;
    box-shadow: 0 6px 32px rgba(0, 0, 0, .13)
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item.pn-bank-item-disable {
    background: #f9f9f9;
    cursor: default
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item.pn-bank-item-disable.single {
    background: #fff;
    cursor: pointer
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item.pn-bank-item-disable.single .bank-logo {
    opacity: 1
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item.pn-bank-item-disable .bank-logo {
    top: 14px;
    opacity: .5
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item.pn-bank-item-disable .card-type {
    top: 14px;
    opacity: .5
  }

  .pay-newUserPromotion .pn-bank .pn-bank-item.pn-bank-item-disable .disable-text {
    display: block;
    position: absolute;
    bottom: -1px;
    left: -1px;
    width: 204px;
    height: 28px;
    line-height: 28px;
    color: #bbb;
    background-color: #f8f8f8;
    overflow: hidden;
    font-family: "Microsoft Yahei";
    text-indent: 15px
  }

  .pay-newUserPromotion .pn-more {
    text-align: center;
    padding-top: 5px;
    margin-bottom: 20px
  }

  .pay-newUserPromotion .pn-more a {
    display: inline-block;
    position: relative;
    line-height: 28px;
    padding-right: 16px;
    cursor: pointer
  }

  .pay-newUserPromotion .pn-more a:hover {
    color: #67a4ff
  }

  .pay-newUserPromotion .pn-more a i {
    position: absolute;
    right: 0;
    top: 11px;
    display: block;
    width: 12px;
    height: 7px;
    background: url(//storage.jd.com/payment-assets/pc/icon/newUser-more.png) no-repeat
  }

  .pay-newUserPromotion .pn-other {
    padding-bottom: 30px;
    padding-left: 13px
  }

  .pay-newUserPromotion .pn-other .pn-o-button {
    position: relative;
    display: inline-block;
    margin-right: 8px;
    width: 218px;
    height: 80px;
    border: 1px solid #efefef;
    line-height: 80px;
    font-size: 14px;
    text-align: center;
    font-family: "Microsoft Yahei";
    transition: all .2s ease-in-out
  }

  .pay-newUserPromotion .pn-other .pn-o-button:hover {
    border-color: #fff;
    box-shadow: 0 6px 32px rgba(0, 0, 0, .13)
  }

  .pay-newUserPromotion .pn-other .pn-o-button .coupon {
    position: absolute;
    color: #e31613;
    top: 18px;
    left: 50%;
    margin-left: -40px
  }

  .pay-newUserPromotion .pn-other .pn-o-button:hover {
    color: #67a4ff
  }

  .pay-newUserPromotion .pn-other .pn-o-button i {
    position: relative;
    left: -2px;
    top: 2px;
    display: block
  }

  .pay-newUserPromotion .pn-other .pn-o-button.pn-o-button-wangyin {
    text-indent: 20px
  }

  .pay-newUserPromotion .pn-other .pn-o-button.pn-o-button-wangyin i {
    width: 17px;
    height: 14px;
    display: inline-block;
    background: url(//storage.jd.com/payment-assets/pc/icon/newUser-wangyin.png) no-repeat
  }

  .result-pay-box {
    padding-top: 30px
  }

  .result-blue {
    color: #67a4ff
  }

  .result-pay-failure .rp-ico, .result-pay-success .rp-ico {
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/pay-result.png)
  }

  .po_r {
    position: relative;
    height: 33px
  }

  .result-pay {
    padding: 20px 20px 0;
    background: #fff
  }

  .result-pay .rp-box {
    position: relative;
    height: auto;
    padding: 13px 0 20px 300px
  }

  .result-pay .rp-title {
    font: 700 24px/48px "Microsoft Yahei"
  }

  .result-pay .rp-tip {
    height: 20px;
    line-height: 20px
  }

  .result-pay .rp-l {
    width: 20px;
    margin: 0 10px;
    color: #ddd;
    text-align: center
  }

  .result-pay .rp-link {
    display: inline-block;
    height: 20px;
    padding-left: 23px;
    margin-left: 8px;
    margin-right: 7px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/bao.png) 0 0 no-repeat
  }

  .result-pay .rp-info {
    padding: 23px 0 0 300px
  }

  .result-pay .rp-info .rp-price {
    color: #e31613;
    font-weight: 700
  }

  .result-pay .rp-msg {
    padding: 20px 0 0 300px;
    line-height: 24px
  }

  .result-pay .rp-msg .rp-m-label {
    display: inline-block;
    text-align: left
  }

  .result-pay .p-extra {
    line-height: 24px
  }

  .result-pay .rp-detail {
    padding: 30px 0 40px 300px
  }

  .result-pay .rp-detail .rp-d-left {
    float: left;
    width: 200px;
    min-height: 105px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/loading.gif) no-repeat center center
  }

  .result-pay .rp-detail .rp-d-left .rp-msg {
    padding: 0;
    background: #fff
  }

  .result-pay .rp-detail .rp-d-left .rp-btn-box {
    padding: 0;
    padding-top: 13px;
    padding-bottom: 10px;
    background: #fff
  }

  .result-pay .rp-detail .rp-d-right {
    float: left;
    padding-left: 30px;
    width: 150px;
    border-left: 1px dashed #ddd
  }

  .result-pay .rp-detail .rp-d-right .rp-qrcode {
    padding-top: 3px
  }

  .result-pay .rp-detail .rp-d-right .rp-qrcode .rp-qrcode-img {
    width: 122px;
    height: 80px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/result-qrcode.png) no-repeat
  }

  .result-pay .rp-detail .rp-d-right .rp-qrcode .rp-qrcode-text {
    line-height: 26px;
    color: #999
  }

  .result-pay .rp-detail .rp-d-app {
    float: left;
    height: 89px;
    padding-left: 30px;
    padding-top: 20px;
    border-left: 1px dashed #ddd
  }

  .result-pay .rp-detail .rp-d-app .rp-app .rp-app-btn {
    display: block;
    position: relative;
    width: 130px;
    height: 32px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/pay-result-app-btn.png) no-repeat;
    margin-bottom: 5px
  }

  .result-pay .rp-detail .rp-d-app .rp-app .rp-app-btn i {
    display: none;
    position: absolute;
    left: -2px;
    top: 18px;
    width: 133px;
    height: 161px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/pay-result-app-btn.png) no-repeat 0 -42px
  }

  .result-pay .rp-detail .rp-d-app .rp-app .rp-app-btn:hover i {
    display: block
  }

  .result-pay .rp-detail .rp-d-app .rp-app .rp-app-text {
    text-align: center;
    color: #ea544a;
    line-height: 20px
  }

  .result-pay .rp-detail .rp-d-baitiao {
    float: left;
    padding-left: 30px;
    width: 150px;
    border-left: 1px dashed #ddd
  }

  .result-pay .rp-detail .rp-d-baitiao .rp-b-qrcode {
    padding-top: 3px
  }

  .result-pay .rp-detail .rp-d-baitiao .rp-b-qrcode .rp-b-qrcode-img {
    width: 270px;
    height: 96px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/result-qrcode-baitiao.png) no-repeat
  }

  .result-pay .rp-member {
    margin-top: 30px;
    height: 34px;
    line-height: 34px;
    background: #f0fbf4;
    border: 1px dashed #69cd8e;
    display: inline-block;
    *display: inline;
    *zoom: 1
  }

  .result-pay .rp-member .rp-member-wrap {
    padding: 0 40px
  }

  .result-pay .rp-member strong {
    color: #69cd8e
  }

  .result-pay .rp-baitiao {
    width: 950px;
    height: 80px;
    padding-bottom: 20px
  }

  .result-pay .rp-baitiao a {
    display: block;
    width: 100%;
    height: 100%;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/pay-result-baitiao.png) no-repeat center center
  }

  .result-pay-failure {
    border-top: 4px solid #e31613;
    box-shadow: 0 0 20px rgba(0, 0, 0, .12)
  }

  .result-pay-failure .rp-ico {
    position: absolute;
    top: 25px;
    left: 260px;
    _left: -35px;
    overflow: hidden;
    width: 26px;
    height: 26px;
    background-position: 0 -27px
  }

  .result-pay-failure .rp-box {
    background: #fff1f1
  }

  .result-pay-failure .rp-title {
    color: #e31613
  }

  .result-pay-failure .rp-btn-box {
    padding: 16px 0 60px 300px
  }

  .result-pay-failure .rp-btn-box .ui-button {
    color: #fff
  }

  .result-pay-success {
    border-top: 4px solid #69cd8e
  }

  .result-pay-success .rp-ico {
    position: absolute;
    top: 26px;
    left: 258px;
    _left: -35px;
    width: 28px;
    height: 24px;
    overflow: hidden;
    background-position: 0 0
  }

  .result-pay-success .rp-box {
    background: #f0fbf4
  }

  .result-pay-success .rp-title {
    color: #69cd8e
  }

  .result-pay-success .rp-btn-box {
    padding: 13px 0 43px 300px
  }

  .result-pay-success .rp-btn-box .rp-btn {
    display: inline-block;
    height: 34px;
    padding: 0 25px;
    border: 1px solid #999;
    border-radius: 2px;
    background: #f1f2f7;
    color: #666;
    line-height: 34px;
    text-align: center
  }

  .result-pay-success .rp-btn-box .rp-btn-link {
    margin-left: 20px;
    color: #67a4ff
  }

  .result-pay-success .rp-btn-box .rp-l {
    color: #67a4ff
  }

  .result-pay-success .rp-btn-box .rp-btn-baitiao {
    margin-left: -12px;
    display: inline-block;
    height: 70px;
    width: 120px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/btn-baitiao.gif) no-repeat
  }

  .result-pay-success .rp-btn-box .rp-btn-baitiao-guangguang {
    display: inline-block;
    margin-top: 44px;
    margin-left: 20px;
    line-height: 20px
  }

  .result-recommend {
    padding: 10px 20px 20px;
    margin-top: 20px;
    background: #fff
  }

  .result-recommend .title {
    height: 40px
  }

  .result-recommend .title .name {
    font: normal 20px/40px "microsoft yahei"
  }

  .result-recommend .o-slide {
    float: left;
    overflow: hidden;
    background: #fff;
    width: 352px;
    height: 459px
  }

  .result-recommend .o-slide .slide {
    position: relative;
    height: 459px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/loading.gif) no-repeat center center
  }

  .result-recommend .o-slide .slide-items {
    width: 353px;
    height: 459px;
    overflow: hidden
  }

  .result-recommend .o-slide .slide-controls {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 3;
    width: 353px;
    height: 30px;
    overflow: hidden;
    text-align: center;
    font-size: 0
  }

  .result-recommend .o-slide .slide-controls span {
    display: inline-block;
    margin: 0 1px;
    cursor: default;
    width: 36px;
    padding: 5px 0
  }

  .result-recommend .o-slide .slide-controls span b {
    display: block;
    height: 5px;
    overflow: hidden;
    background: #999
  }

  .result-recommend .o-slide .slide-controls .curr b {
    background: #69cd8e
  }

  .result-recommend .o-goods {
    float: left;
    overflow: hidden;
    width: 598px;
    height: 458px;
    border-top: 1px solid #ddd
  }

  .result-recommend .o-goods li {
    float: left;
    width: 298px;
    height: 228px;
    overflow: hidden;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/loading.gif) no-repeat center center
  }

  .result-recommend .o-goods li img {
    width: 298px;
    height: 228px
  }

  .risk-modal {
    width: 660px;
    margin-left: -330px
  }

  .risk-modal .risk-c-result {
    position: relative;
    padding-left: 200px;
    margin-bottom: 30px;
    height: 48px
  }

  .risk-modal .risk-c-result i {
    position: absolute;
    top: 14px;
    left: 158px;
    width: 28px;
    height: 24px;
    overflow: hidden;
    display: block;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/pay-result.png) no-repeat
  }

  .risk-modal .risk-c-result em {
    color: #69cd8e;
    font: 700 24px/48px "Microsoft Yahei"
  }

  .risk-modal .risk-c-success {
    position: relative;
    padding-left: 260px;
    margin-bottom: 35px;
    height: 80px;
    background: #f0fbf4
  }

  .risk-modal .risk-c-success i {
    position: absolute;
    top: 30px;
    left: 218px;
    width: 28px;
    height: 24px;
    overflow: hidden;
    display: block;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/pay-result.png) no-repeat
  }

  .risk-modal .risk-c-success em {
    color: #69cd8e;
    font: 700 24px/80px "Microsoft Yahei"
  }

  .risk-modal .risk-c-title {
    position: relative;
    padding-left: 155px;
    margin-bottom: 35px
  }

  .risk-modal .risk-c-title em {
    font-weight: 700;
    font-size: 14px;
    display: block;
    line-height: 22px;
    margin-bottom: 15px
  }

  .risk-modal .risk-c-title i {
    position: absolute;
    left: 30px;
    top: 4px;
    display: block;
    width: 94px;
    height: 90px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png) no-repeat -3px -478px
  }

  .risk-modal .risk-c-title p {
    line-height: 22px
  }

  .risk-modal .risk-c-title.no-icon {
    padding-left: 0
  }

  .risk-modal .risk-c-title.no-icon i {
    display: none
  }

  .risk-modal .risk-c-line {
    height: 50px;
    line-height: 50px;
    background: #f7f7f7;
    padding-left: 20px;
    margin-bottom: 30px
  }

  .risk-modal .risk-c-button {
    text-align: center
  }

  .result-box {
    padding-top: 30px
  }

  .result-box .result-box-wrap {
    border-top: 4px solid #69cd8e;
    background: #f6f6f6;
    box-shadow: 0 0 20px rgba(0, 0, 0, .12)
  }

  .result-box .result-box-left {
    float: left;
    height: 345px;
    width: 600px;
    padding: 0 50px 20px;
    background-color: #fff
  }

  .result-box .result-box-right {
    float: right;
    width: 290px
  }

  .result-box .result-division {
    margin: 0 5px;
    color: #ddd;
    text-align: center
  }

  .result-box .result-box-title {
    padding-left: 45px;
    padding-top: 30px;
    margin-bottom: 25px;
    position: relative
  }

  .result-box .result-box-title .title-icon {
    position: absolute;
    display: block;
    left: 8px;
    top: 43px;
    width: 28px;
    height: 24px;
    overflow: hidden;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/pay-result.png) no-repeat;
    background-position: 0 0
  }

  .result-box .result-box-title .title-redirect {
    margin-left: 10px;
    font-size: 12px;
    color: #999;
    font-family: Arial, Verdana, "\5b8b\4f53";
    font-weight: 400
  }

  .result-box .result-box-title h2 {
    font: 700 24px/48px "Microsoft Yahei"
  }

  .result-box .result-box-detail {
    padding-left: 45px;
    margin-bottom: 15px
  }

  .result-box .result-box-detail .detail-line {
    line-height: 24px
  }

  .result-box .result-box-operate {
    padding-left: 45px;
    border-bottom: 1px dashed #e2e2e2;
    padding-bottom: 20px;
    margin-bottom: 20px;
    line-height: 32px
  }

  .result-box .result-box-operate a {
    vertical-align: middle
  }

  .result-box .result-box-operate .operate-btn {
    display: inline-block;
    width: 120px;
    height: 32px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/btn-result-baitiao.gif) no-repeat
  }

  .result-box .result-box-operate .operate-link-assistant {
    position: relative;
    cursor: default
  }

  .result-box .result-box-operate .operate-link-assistant .ola-box {
    visibility: hidden;
    position: absolute;
    display: block;
    left: 58px;
    top: -66px;
    width: 108px;
    background: #fff;
    box-shadow: 0 0 8px rgba(0, 0, 0, .15);
    border: 1px solid #e6e6e6;
    line-height: 18px;
    z-index: 100
  }

  .result-box .result-box-operate .operate-link-assistant .ola-box .ola-box-qrcode {
    padding: 5px 0 0 0;
    display: block;
    text-align: center;
    margin-bottom: 2px;
    background: url(//img30.360buyimg.com/jr_image/jfs/t2002/227/1088534248/34939/e3200b38/567120eeN08fd2475.gif) center center no-repeat
  }

  .result-box .result-box-operate .operate-link-assistant .ola-box .ola-box-text {
    padding: 0 10px 10px 10px;
    display: block;
    text-align: center;
    color: #666
  }

  .result-box .result-box-operate .operate-link-assistant:hover .ola-box {
    visibility: visible
  }

  .result-box .result-box-tips {
    padding-left: 45px;
    padding-bottom: 30px
  }

  .result-box .result-box-tips .tips-title {
    float: left;
    font-weight: 700;
    line-height: 22px
  }

  .result-box .result-box-tips .tips-content {
    padding-left: 64px;
    line-height: 22px
  }

  .result-box .result-box-qrcode {
    padding-left: 30px;
    padding-top: 60px
  }

  .result-box .result-box-qrcode .qrcode-item {
    padding: 15px 5px 15px 15px;
    width: 210px;
    height: 80px;
    background: #fff;
    margin-bottom: 20px;
    overflow: hidden;
    _zoom: 1
  }

  .result-box .result-box-qrcode .qrcode-item .qrcode-item-img {
    float: left;
    width: 74px;
    height: 74px
  }

  .result-box .result-box-qrcode .qrcode-item .qrcode-item-content {
    float: left;
    line-height: 22px;
    padding-top: 14px;
    padding-left: 15px
  }

  .result-box .result-box-right {
    position: relative;
    height: 365px;
    overflow: hidden
  }

  .result-box .result-box-promotion {
    position: absolute;
    left: 0;
    top: 365px;
    width: 290px;
    height: 365px
  }

  .result-box .result-box-promotion .promotion-item {
    width: 100%;
    height: 100%
  }

  .result-box .result-box-promotion .promotion-item .promotion-item-close {
    display: block;
    position: absolute;
    width: 25px;
    height: 25px;
    background: 0 0;
    top: 8px;
    left: 258px;
    z-index: 100;
    cursor: pointer
  }

  .result-box .result-box-promotion .promotion-item .promotion-item-wrap {
    display: block;
    width: 100%;
    height: 100%
  }

  .result-box .result-box-promotion .promotion-item .promotion-item-wrap .promotion-item-img {
    display: block;
    position: absolute;
    top: 130px;
    left: 81px;
    width: 130px;
    height: 130px
  }

  .result-box .result-box-promotion .promotion-item .promotion-item-wrap b, .result-box .result-box-promotion .promotion-item .promotion-item-wrap em {
    width: 100%;
    font-family: "Microsoft Yahei";
    display: block;
    text-align: center;
    position: absolute;
    color: #f93f1c;
    font-weight: 700
  }

  .result-box .result-box-promotion .promotion-item .promotion-item-wrap em {
    top: 42px;
    font-size: 18px;
    line-height: 20px
  }

  .result-box .result-box-promotion .promotion-item .promotion-item-wrap b {
    top: 68px;
    font-size: 36px;
    line-height: 40px
  }

  .result-success .result-box-title h2 {
    color: #69cd8e
  }

  .result-success .result-box-title .setpwd-btn b {
    font-weight: 400;
    font-family: "\5b8b\4f53"
  }

  .result-global-error .result-box-wrap {
    border-color: #4b5b78
  }

  .result-global-error .global-error-box {
    background-color: #fff;
    padding: 90px 0 150px 290px
  }

  .result-global-error .global-error-box h3 {
    position: relative;
    font-family: "Microsoft Yahei", "å¾®è½¯é›…é»‘";
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 10px;
    color: #333
  }

  .result-global-error .global-error-box h3 .ge-icon {
    position: absolute;
    left: -60px;
    top: 0;
    width: 42px;
    height: 42px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png) no-repeat -60px -350px
  }

  .porm-result .shortcut {
    padding-bottom: 10px
  }

  .porm-result .shortcut .w {
    width: 1100px
  }

  .porm-result .main {
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/porm-result-bg.png) no-repeat top center;
    margin-bottom: 60px;
    padding-bottom: 120px
  }

  .w-porm-result {
    padding-top: 20px;
    width: 1100px
  }

  .porm-result-box {
    padding-left: 54px;
    background: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, .12);
    position: relative;
    margin-bottom: 38px
  }

  .porm-result-box .porm-result-division {
    margin: 0 5px;
    color: #ddd;
    text-align: center
  }

  .porm-result-box .prb-info {
    width: 560px;
    padding-top: 36px
  }

  .porm-result-box .prb-info .prb-info-left {
    float: left;
    width: 230px;
    margin-right: 10px
  }

  .porm-result-box .prb-info .prb-info-right {
    float: left;
    width: 300px
  }

  .porm-result-box .prb-info .prb-info-icon {
    display: block;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/porm-result-success.png) no-repeat;
    width: 41px;
    height: 41px;
    margin-bottom: 5px
  }

  .porm-result-box .prb-info .prb-info-text {
    font-family: "Microsoft Yahei";
    font-size: 18px;
    line-height: 32px;
    height: 64px;
    color: #47cf9f;
    font-weight: 700;
    margin-bottom: 12px
  }

  .porm-result-box .prb-info .prb-info-operate {
    line-height: 24px;
    margin-bottom: 28px
  }

  .porm-result-box .prb-info .prb-info-tips {
    border-top: 1px solid #ececec;
    padding-top: 12px;
    padding-bottom: 26px
  }

  .porm-result-box .prb-info .prb-info-tips .prb-info-tips-text {
    line-height: 20px;
    color: #a5a5a5
  }

  .porm-result-box .prb-info .prb-info-data {
    border-collapse: collapse;
    border-spacing: 0;
    height: 159px
  }

  .porm-result-box .prb-info .prb-info-data td {
    vertical-align: middle
  }

  .porm-result-box .prb-info .prb-info-data td span {
    display: block;
    line-height: 18px;
    margin-top: 12px
  }

  .porm-result-box .prb-info .prb-info-data td .p-extra {
    display: block;
    line-height: 18px;
    margin-top: 12px
  }

  .porm-result-box .prb-promtion {
    position: absolute;
    width: 420px;
    height: 180px;
    right: 35px;
    top: 44px
  }

  .porm-result-box .prb-promtion .prb-promotion-item-wrap {
    display: block;
    width: 420px;
    height: 180px;
    background-repeat: no-repeat
  }

  .porm-box .porm-box-first {
    height: 680px;
    background-color: #191b20;
    position: relative
  }

  .porm-box .porm-box-first .pbf-left {
    float: left;
    width: 264px;
    height: 530px;
    background: #191b20;
    position: relative
  }

  .porm-box .porm-box-first .pbf-left .pbf-left-wrap {
    cursor: pointer;
    width: 264px;
    height: 253px;
    position: absolute;
    top: -20px;
    left: 0;
    transition: all .3s ease
  }

  .porm-box .porm-box-first .pbf-left .pbf-left-wrap a {
    display: block
  }

  .porm-box .porm-box-first .pbf-left .pbf-left-wrap:hover {
    -ms-transform: translateY(-5px);
    transform: translateY(-5px)
  }

  .porm-box .porm-box-first .pbf-left .pbf-left-bg {
    position: absolute;
    width: 263px;
    height: 239px;
    top: 101px;
    left: 0;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/pbf-left-bg.png) no-repeat
  }

  .porm-box .porm-box-first .pbf-left .pbf-left-content {
    width: 264px;
    height: 160px;
    position: absolute;
    left: 0;
    top: 160px
  }

  .porm-box .porm-box-first .pbf-left .pbf-left-content .pbf-left-content-1 {
    display: block;
    font-family: "Microsoft Yahei";
    font-size: 18px;
    line-height: 32px;
    color: #fff;
    font-weight: 700;
    font-style: italic;
    text-align: center
  }

  .porm-box .porm-box-first .pbf-left .pbf-left-content .pbf-left-content-2 {
    display: block;
    font-family: "Microsoft Yahei";
    font-size: 18px;
    line-height: 32px;
    color: #fff;
    font-weight: 700;
    font-style: italic;
    text-align: center;
    margin-left: -30px;
    margin-bottom: 30px
  }

  .porm-box .porm-box-first .pbf-left .pbf-left-content .pbf-left-content-operate {
    text-align: center
  }

  .porm-box .porm-box-first .pbf-left .pbf-left-content .pbf-left-content-button {
    display: inline-block;
    width: 188px;
    height: 46px;
    color: #fff;
    font-size: 16px;
    line-height: 46px;
    font-family: "Microsoft Yahei";
    border-radius: 22px;
    font-weight: 700;
    background: #f52f3e;
    background-repeat: repeat-x;
    background-image: linear-gradient(to right, #f52f3e, #ff4c22);
    transition: all .3s ease
  }

  .porm-box .porm-box-first .pbf-left .pbf-left-content .pbf-left-content-button:hover {
    -ms-transform: translateY(-3px);
    transform: translateY(-3px)
  }

  .porm-box .porm-box-first .pbf-right {
    float: left;
    width: 836px;
    height: 680px;
    position: relative
  }

  .porm-box .porm-box-first .pbf-right .pbf-right-1 {
    position: absolute;
    width: 836px;
    height: 185px;
    left: 0;
    top: 0;
    background-image: url(//misc.360buyimg.com/lib/img/e/blank.gif)
  }

  .porm-box .porm-box-first .pbf-right .pbf-right-list {
    position: absolute;
    width: 142px;
    height: 129px;
    top: 212px;
    transition: all .3s ease
  }

  .porm-box .porm-box-first .pbf-right .pbf-right-list:hover {
    -ms-transform: translateY(-3px);
    transform: translateY(-3px)
  }

  .porm-box .porm-box-first .pbf-right .pbf-right-2 {
    left: 50px
  }

  .porm-box .porm-box-first .pbf-right .pbf-right-3 {
    left: 202px
  }

  .porm-box .porm-box-first .pbf-right .pbf-right-4 {
    left: 354px
  }

  .porm-box .porm-box-first .pbf-right .pbf-right-5 {
    left: 506px
  }

  .porm-box .porm-box-first .pbf-right .pbf-right-6 {
    left: 658px
  }

  .porm-box .porm-box-first .pbf-market {
    position: absolute;
    width: 1048px;
    height: 334px;
    left: 26px;
    top: 381px
  }

  .porm-box .porm-box-first .pbf-market .pbf-market-side {
    float: left;
    overflow: hidden;
    background: #fff;
    width: 474px;
    height: 334px
  }

  .porm-box .porm-box-first .pbf-market .pbf-market-list {
    float: left;
    overflow: hidden;
    width: 574px;
    height: 334px
  }

  .porm-box .porm-box-first .pbf-market .pbf-market-list li {
    float: left;
    width: 286px;
    height: 167px;
    border-right: 1px solid #f2f2f2;
    border-bottom: 1px solid #f2f2f2
  }

  .porm-box .porm-box-first .pbf-market .pbf-market-list li a {
    width: 286px;
    height: 167px
  }

  .porm-box .porm-box-first .pbf-market .pbf-market-list li.pbf-market-list-item-2 {
    border-right: 0 none
  }

  .porm-box .porm-box-first .pbf-market .pbf-market-list li.pbf-market-list-item-3 {
    border-bottom: 0 none
  }

  .porm-box .porm-box-first .pbf-market .pbf-market-list li.pbf-market-list-item-4 {
    border-right: 0 none;
    border-bottom: 0 none
  }

  .p-active-wrap {
    background-repeat: no-repeat;
    width: 396px;
    height: 498px;
    position: absolute;
    left: 50%;
    z-index: 10001;
    text-align: center;
    color: #fff;
    font-family: Arial, 'Microsoft Yahei', '\5FAE\8F6F\96C5\9ED1', 'Hiragino Sans GB', '\5B8B\4F53'
  }

  .p-active-wrap .prize-text {
    font-weight: 700;
    font-size: 36px;
    padding-top: 180px;
    min-height: 18px;
    text-shadow: 0 5px 9px #fd2111
  }

  .p-active-wrap .prize-num {
    font-size: 60px;
    font-weight: 700;
    padding-top: 45px;
    text-shadow: 0 5px 9px #fd2111
  }

  .p-active-wrap .prize-num .prize-unit {
    font-size: 20px
  }

  .p-active-wrap .prize-tips {
    min-height: 18px;
    font-size: 14px;
    font-weight: 700;
    padding-top: 20px
  }

  .p-active-wrap .active-detail a {
    font-weight: 700;
    font-size: 14px;
    color: #fff727;
    padding-top: 10px
  }

  .p-active-wrap .active-link {
    padding-top: 15px
  }

  .p-active-wrap .active-link a {
    margin: 0 3px;
    width: 128px;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    box-shadow: 0 2px 0 #e1b34d;
    font-size: 14px;
    font-weight: 700;
    color: #fefefe;
    display: inline-block;
    background-image: linear-gradient(#e1b34d, #e1b34d)
  }

  .p-active-wrap .prize-return {
    color: #fff727;
    font-weight: 700;
    padding-top: 10px
  }

  .p-active-wrap .prize-return span {
    color: #fa0;
    font-weight: 400;
    padding-left: 5px
  }

  .p-active-wrap .close-prize {
    width: 40px;
    height: 40px;
    position: absolute;
    left: 50%;
    bottom: 0;
    margin-left: -20px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/close-bg.png) no-repeat
  }

  .pn-newforeignCard {
    margin-left: 10px;
    height: 34px;
    line-height: 34px;
    width: 138px;
    border: 1px solid #e0e0e0;
    display: inline-block;
    position: relative;
    text-align: center
  }

  .newCard-modal .nm-tab .nm-tab-quick a.addForeignCard_a {
    padding: 0 30px
  }

  .ui-select.ui-select-country {
    width: 228px
  }

  .nw-f-input-address {
    width: 300px
  }

  .nw-form-quick .card-sync {
    top: 200px
  }

  .nw-form-quick.xykfq .card-sync {
    top: 100px
  }

  .changePayType {
    margin-left: 15px;
    cursor: pointer
  }

  .tipShow {
    position: absolute;
    top: -44px;
    left: 15px;
    text-align: center;
    line-height: 40px;
    width: 122px;
    height: 55px;
    color: #fc6b6c;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/instalment_modal-bg.png) no-repeat;
    background-size: 122px 50px
  }

  .ml230 {
    margin-left: 230px
  }

  .tip_hide {
    display: none
  }

  .promotion-float {
    position: absolute;
    top: 80px;
    left: 50%;
    width: 88px;
    margin-left: -583px
  }

  .promotion-float .pf-item {
    display: block;
    width: 78px;
    height: 180px;
    margin-bottom: 9px;
    box-shadow: 0 0 20px rgba(0, 0, 0, .12)
  }

  .ui-modal-wrap {
    border: none
  }

  .pay_qrcode-modal {
    position: relative;
    border-radius: 20px;
    width: 290px;
    height: 370px;
    border: none;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/qrcode_bg.png) no-repeat;
    overflow: hidden
  }

  .pay_qrcode-modal .ui-modal-inner {
    position: relative;
    margin-top: 50px;
    width: 290px;
    height: 303px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/qrcode_bg3.png) no-repeat 13px
  }

  .pay_qrcode-modal .ui-modal-inner .modal-content {
    position: absolute;
    text-align: center;
    top: 30px;
    width: 290px;
    height: 299px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/qrcode_bg2.png) no-repeat -5px
  }

  .pay_qrcode-modal .ui-modal-inner .qrcode-info {
    text-align: center
  }

  .btn-detail {
    display: inline-block;
    margin-top: 32px;
    cursor: pointer;
    width: 202px;
    height: 62px;
    line-height: 53px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/detail_bg.png) no-repeat;
    background-size: 100%;
    font-size: 16px;
    color: #d83133;
    font-weight: 700
  }

  .btn-detail:hover {
    color: #2e394e
  }

  .close-qrcode {
    position: absolute;
    left: 125px;
    width: 38px;
    height: 38px;
    display: inline-block;
    top: 380px;
    cursor: pointer;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/close-bg.png) no-repeat
  }

  .qrcode-info {
    padding-top: 37px;
    font-size: 14px
  }

  .qrcode-info p {
    margin-top: 28px
  }

  .qrcode-info h3 {
    margin-top: 8px;
    font-size: 20px;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: 700;
    color: #2e394e
  }

  .qrcode-info .color_red {
    color: #d31f29
  }

  .qrcode-info .qrcode_img {
    margin-left: 3px
  }

  .baitiaoActive-content .ui-select {
    width: 340px;
    padding-left: 10px
  }

  .baitiaoActive-content .ui-form .ui-form-label {
    width: 130px;
    margin-right: 30px
  }

  .p-quick-value.p-value {
    margin-left: 155px
  }

  .p-quick-wrap.p-wrap {
    padding-bottom: 0
  }

  .baitiao-coupon.ui-form-group {
    margin-left: 0
  }

  .ui-form-line.baitiao-coupon {
    margin-bottom: 5px
  }

  .btQicuk-line .pl-wrap .pl-item {
    height: 32px
  }

  .btQicuk-line .pl-wrap .pl-item .pl-i-fenqi, .btQicuk-line .pl-wrap .pl-item .pl-i-text {
    display: inline;
    line-height: 32px
  }

  .ui-form .ui-form-group.agreement {
    margin-left: 160px
  }

  .ui-form .ui-form-group.agreement .disable {
    background: #fcb4b3;
    border: none;
    cursor: pointer
  }

  .cu-select-l.select-card {
    width: 310px
  }

  .bankIco {
    width: 20px;
    margin-right: 5px;
    margin-top: -4px
  }

  .longPwd .tipShow {
    left: 135px
  }

  .fail-quick {
    display: inline-block;
    margin: 0 auto;
    width: 142px;
    height: 163px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/kauijie_img1.png) no-repeat
  }

  .cu-select-l.select-card span.title a {
    color: #666
  }

  .j_paybox.paybox-baitiao {
    border-bottom: 0
  }

  .baitiaoActive-result {
    width: 500px;
    margin: 100px auto;
    text-align: center
  }

  .baitiaoQuickCoupo-modal {
    width: 888px
  }

  .baitiaoQuickCoupo-modal.ui-modal .ui-modal-content {
    padding: 20px 0
  }

  .agreementWrap {
    position: absolute;
    width: 260px;
    bottom: 30px;
    left: 135px;
    z-index: 2;
    background: #fff
  }

  .agreementList {
    border: 2px solid #e1e1e1;
    padding-left: 20px;
    box-shadow: #f7f7f7 3px 3px 10px
  }

  .agreementList li i {
    display: inline-block;
    width: 4px;
    height: 4px;
    background: #83cbf1;
    position: relative;
    top: -3px;
    left: -3px
  }

  .agreementList li a:hover i {
    background: #e31613
  }

  .spread i {
    display: inline-block;
    width: 14px;
    height: 12px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/spread_bg.png) no-repeat;
    position: absolute;
    bottom: -10px;
    left: 120px;
    z-index: 10
  }

  span.baitiaoWrap {
    color: #2ea7e7;
    cursor: pointer;
    display: inline-block
  }

  span.baitiaoWrap:hover {
    color: #e31613
  }

  span.baitiaoWrap:hover .agreementWrap {
    display: block
  }

  .baitiaoLoading {
    z-index: 99;
    position: absolute;
    width: 868px;
    height: 504px;
    background: #fff url(//storage.360buyimg.com/payment-assets/pc/icon/baitiaoLoading.gif?20170526) no-repeat
  }

  .um-h-close.um-h-close {
    position: absolute;
    right: 15px;
    width: 38px;
    height: 38px;
    display: inline-block;
    top: 10px;
    cursor: pointer;
    background: url(//sp.jd.com/payment/2.0.0/css/i/close-bg.png) no-repeat
  }

  .order {
    position: relative;
    *zoom: 1
  }

  .order .o-left {
    float: left;
    width: 640px;
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 102px
  }

  .order .o-right {
    float: right;
    width: 190px;
    padding-top: 32px;
    padding-bottom: 10px;
    padding-right: 10px;
    overflow: hidden
  }

  .order .o-title {
    line-height: 26px;
    height: 26px;
    overflow: hidden;
    color: #333;
    font-weight: 400;
    font-size: 14px;
    font-family: "Microsoft Yahei"
  }

  .order .o-tips {
    line-height: 20px;
    height: 20px
  }

  .order .o-tips .o-tips-div {
    color: #999;
    margin: 0 5px
  }

  .order .o-tips .o-tips-app-jd, .order .o-tips .o-tips-app-jdjr {
    width: 16px;
    height: 16px;
    display: inline-block;
    margin: 0 2px;
    vertical-align: text-bottom
  }

  .order .o-tips .o-tips-app-jd {
    background: url(//storage.jd.com/payment-assets/pc/icon/app-icon-jd.png) no-repeat
  }

  .order .o-tips .o-tips-app-jdjr {
    background: url(//storage.jd.com/payment-assets/pc/icon/app-icon-jdjr.png) no-repeat
  }

  .order .o-price {
    text-align: right;
    line-height: 26px
  }

  .order .o-price em {
    vertical-align: bottom
  }

  .order .o-price strong {
    font-size: 18px;
    vertical-align: bottom;
    color: #e31613;
    margin: 0 3px
  }

  .order .o-detail {
    text-align: right;
    line-height: 20px;
    color: #67a4ff
  }

  .order .o-detail a {
    display: inline-block;
    padding-right: 15px;
    position: relative;
    *zoom: 1
  }

  .order .o-detail a i {
    right: 0;
    top: 3px;
    position: absolute;
    display: block;
    width: 12px;
    height: 12px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png?20160328) no-repeat -76px -75px
  }

  .order .o-detail a:hover i {
    background-position: -76px -221px
  }

  .order .o-detail a.opened i {
    background-position: -76px -55px
  }

  .order .o-detail a.opened:hover i {
    background-position: -76px -201px
  }

  .order .o-qrcode {
    position: absolute;
    left: 0;
    top: 10px;
    width: 90px;
    height: 90px
  }

  .order .o-qrcode .oq-img {
    width: 88px;
    height: 88px;
    padding: 1px;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 16;
    cursor: default;
    background: #fff url(//storage.360buyimg.com/payment-assets/pc/icon/loading.gif) no-repeat center center;
    box-shadow: 0 0 20px rgba(0, 0, 0, .12)
  }

  .order .o-qrcode .oq-img img {
    width: 88px;
    height: 88px
  }

  .order .o-qrcode .op-phone {
    width: 45px;
    height: 80px;
    left: 36px;
    top: 6px;
    position: absolute;
    z-index: 15;
    background-image: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png?20160328);
    background-repeat: no-repeat;
    background-position: -2px -352px;
    transition: left .2s ease-in-out
  }

  .order .o-qrcode .op-arrow {
    display: none;
    width: 7px;
    height: 8px;
    left: 75px;
    top: 18px;
    position: absolute;
    z-index: 17;
    background-image: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png?20160328);
    background-repeat: no-repeat;
    background-position: -81px -352px;
    opacity: 0;
    transition: all .2s ease-in-out
  }

  .order .o-qrcode .oq-tips {
    position: absolute;
    display: block;
    height: 38px;
    line-height: 38px;
    padding: 0 40px 0 15px;
    background: #fff;
    left: 100px;
    bottom: 0;
    box-shadow: 0 0 20px rgba(0, 0, 0, .12);
    opacity: 0;
    -ms-transform: translateX(5px);
    transform: translateX(5px)
  }

  .order .o-qrcode .oq-tips .oq-tips-content {
    display: block;
    min-width: 232px
  }

  .order .o-qrcode .oq-tips .oq-tips-content em {
    color: #e31613
  }

  .order .o-qrcode .oq-tips .oq-tips-arrow {
    position: absolute;
    width: 6px;
    height: 14px;
    left: -6px;
    top: 12px;
    background: url(//storage.jd.com/payment-assets/pc/icon/qrcode-tips-arrow.png) no-repeat
  }

  .order .o-qrcode .oq-tips .oq-tips-close {
    cursor: pointer;
    position: absolute;
    width: 22px;
    height: 22px;
    right: 11px;
    top: 8px;
    background: url(//storage.jd.com/payment-assets/pc/icon/qrcode-tips-close.png) no-repeat
  }

  .order .o-qrcode .oq-tips.oq-tips-show {
    opacity: 1;
    -ms-transform: translateX(0);
    transform: translateX(0)
  }

  .order .o-qrcode.o-qrcode-hover .op-phone {
    left: 88px
  }

  .order .o-qrcode.o-qrcode-hover .op-arrow {
    left: 80px;
    opacity: 1
  }

  .order .o-qrcode.o-qrcode-enhance .oq-img {
    border: 1px solid #fb9d9d;
    padding: 0
  }

  .order .o-qrcode.o-qrcode-enhance .oq-img i {
    position: absolute;
    right: -7px;
    top: 50px;
    width: 7px;
    height: 15px;
    background: url(//storage.jd.com/payment-assets/pc/icon/qrcode-border-arrow.png) no-repeat
  }

  .order .o-couponTips {
    left: 90px;
    background: url(//img30.360buyimg.com/jr_image/jfs/t18004/270/1466268332/1665/95791b54/5acb3765Nf3459e82.jpg) no-repeat;
    position: absolute;
    height: 30px;
    padding-left: 8px;
    line-height: 30px;
    font-size: 12px;
    color: #fff;
    z-index: 20
  }

  .order .o-couponTips p {
    background: linear-gradient(to right, #ff5a00, #ff1536);
    padding: 0 16px;
    border-radius: 30px
  }

  .order .o-list {
    display: none;
    padding: 12px 0 25px 0;
    margin: 0 30px;
    clear: both;
    border-top: 1px solid #ddd
  }

  .order .o-list .o-list-info {
    line-height: 24px
  }

  .order .o-list .o-list-table table {
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
    width: 100%
  }

  .order .o-list .o-list-table table td, .order .o-list .o-list-table table th {
    padding: 0;
    margin: 0
  }

  .order .o-list .o-list-table table th {
    padding-left: 25px;
    text-align: left;
    line-height: 30px;
    height: 30px;
    background-color: #4b5b78;
    color: #fff
  }

  .order .o-list .o-list-table table td {
    padding-left: 25px;
    line-height: 30px;
    height: 30px
  }

  .order .o-list .o-list-table table td.price, .order .o-list .o-list-table table th.price {
    text-align: right;
    padding-right: 30px
  }

  .order .o-list .o-list-table .o-goods-name {
    width: 380px;
    height: 30px;
    overflow: hidden
  }

  .order .o-list .o-list-page {
    height: 20px;
    line-height: 20px;
    padding-top: 10px;
    text-align: center
  }

  .order .o-list .o-list-page .p-item {
    display: inline-block;
    padding: 0 5px
  }

  .order .o-list .o-list-page .p-item.curr {
    font-weight: 700;
    color: #e31613
  }

  .order.order-global .o-left {
    width: 640px
  }

  .order.order-global .o-title {
    font-size: 12px
  }

  .order.order-global .o-title .o-title-success {
    font-size: 14px
  }

  .order.order-global .o-title a {
    font-weight: 400
  }

  .order.order-global .o-tips {
    position: relative
  }

  .order.order-global .o-tips .o-tips-item {
    color: #888
  }

  .order.order-global .o-tips .o-tips-foreign {
    position: absolute;
    top: 0;
    right: -239px;
    text-align: right;
    width: 120px;
    height: 20px;
    display: inline-block;
    color: #888
  }

  .order.order-global .o-right {
    width: 210px
  }

  .order.order-global .o-right .o-price-foreign {
    text-align: right;
    line-height: 18px;
    color: #888
  }

  .order.order-noQrcode .o-left {
    padding-left: 0
  }

  .order.order-noQrcode .o-tips .o-tips-foreign {
    right: -341px
  }

  .order.order-init .o-qrcode {
    visibility: hidden;
    opacity: 0;
    transition: all .2s ease-in-out
  }

  .order.order-init .o-left {
    padding-left: 0;
    transition: all .15s ease-in-out
  }

  .order.order-init .o-tips {
    visibility: hidden;
    opacity: 0;
    transition: all .2s ease-in-out
  }

  .order.order-init .o-tips .o-tips-foreign {
    right: -341px
  }

  .order.order-init.order-init-newUser .o-tips {
    visibility: visible;
    opacity: 1
  }

  .order.order-init.order-init-newUser .o-tips .o-tips-qrcode {
    display: none
  }

  .order.order-init.order-init-newUser .o-tips .o-tips-div {
    display: none
  }

  .order.order-init.order-init-oldUser .o-qrcode {
    visibility: visible;
    opacity: 1
  }

  .order.order-init.order-init-oldUser .o-left {
    padding-left: 102px
  }

  .order.order-init.order-init-oldUser .o-tips {
    visibility: visible;
    opacity: 1
  }

  .order.order-init.order-init-oldUser-noQrcode .o-tips {
    visibility: visible;
    opacity: 1
  }

  .order.order-init.order-init-oldUser-noQrcode .o-tips .o-tips-qrcode {
    display: none
  }

  .order.order-init.order-init-oldUser-noQrcode .o-tips .o-tips-div {
    display: none
  }

  .order.order-init.order-init-global .o-qrcode {
    visibility: visible;
    opacity: 1
  }

  .order.order-init.order-init-global .o-left {
    width: 640px;
    padding-left: 102px
  }

  .order.order-init.order-init-global .o-title {
    font-size: 12px
  }

  .order.order-init.order-init-global .o-title .o-title-success {
    font-size: 14px
  }

  .order.order-init.order-init-global .o-title a {
    font-weight: 400
  }

  .order.order-init.order-init-global .o-tips {
    position: relative;
    visibility: visible;
    opacity: 1
  }

  .order.order-init.order-init-global .o-tips .o-tips-item {
    color: #888
  }

  .order.order-init.order-init-global .o-tips .o-tips-foreign {
    position: absolute;
    top: 0;
    right: -239px;
    text-align: right;
    width: 120px;
    height: 20px;
    display: inline-block;
    color: #888
  }

  .order.order-init.order-init-global .o-right {
    width: 210px
  }

  .order.order-init.order-init-global .o-right .o-price-foreign {
    text-align: right;
    line-height: 18px;
    color: #888
  }

  .newCard-modal {
    width: 852px
  }

  .newCard-modal .nm-tab {
    background: #f7f7f7;
    padding-top: 9px
  }

  .newCard-modal .nm-tab .ui-tab-items {
    padding-left: 30px
  }

  .newCard-modal .nm-tab .ui-tab-items a {
    padding: 0 45px
  }

  .newCard-modal .nm-tab .nm-tab-quick a {
    padding-left: 65px;
    padding-right: 20px
  }

  .newCard-modal .nm-tab .nm-tab-quick i {
    position: absolute;
    top: 12px;
    left: 24px;
    width: 35px;
    height: 14px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png?20160328) -30px -143px no-repeat
  }

  .newCard-modal .nm-close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 20px;
    top: 12px;
    background: url(//storage.jd.com/payment-assets/pc/icon/modal-close.png) no-repeat
  }

  .bank-identific-wrap {
    padding-top: 38px;
    padding-bottom: 10px
  }

  .bank-identific-wrap .ui-form .ui-form-label {
    font-size: 14px;
    font-weight: 700
  }

  .bank-identific-wrap .ui-form .ui-form-line {
    margin-bottom: 0
  }

  .bank-identific-wrap .bank-identific {
    margin-bottom: 0
  }

  .bank-identific-wrap .bank-identific .bi-input {
    height: 24px;
    line-height: 24px;
    margin-top: -2px
  }

  .bank-identific-wrap .bank-identific .bi-input .ui-icon-pen {
    margin-top: 5px;
    margin-right: 5px
  }

  .bank-identific-wrap .bank-identific .bi-input .bi-i-text {
    height: 24px
  }

  .bank-identific-wrap .bank-identific .bi-tips {
    position: absolute;
    left: 0;
    top: -28px;
    line-height: 20px;
    color: #999
  }

  .bank-identific-wrap .um-newcard-bankinfo {
    height: 32px;
    line-height: 32px;
    margin-bottom: 8px
  }

  .bank-identific-wrap .um-newcard-bankinfo .um-nb-error {
    color: #e31613
  }

  .bank-list-wrap .order-by-wrap {
    margin: -5px 0 18px 0
  }

  .bank-list-wrap .order-by-wrap a {
    margin-right: 15px;
    padding: 5px;
    color: #999;
    cursor: pointer
  }

  .bank-list-wrap .order-by-wrap a.active, .bank-list-wrap .order-by-wrap a:hover {
    color: #67a4ff
  }

  .bank-list-wrap .pl-wrap {
    width: 800px
  }

  .nw-form-wrap .auth-tips {
    padding-left: 85px;
    padding-bottom: 10px;
    color: #e31613
  }

  .nw-form-wrap.nw-form-quick .nw-f-input-name {
    width: 110px
  }

  .nw-form-wrap.nw-form-quick .nw-f-input-auth {
    width: 80px
  }

  .nw-form-wrap.nw-form-quick .nw-f-input-phone {
    width: 110px
  }

  .nw-form-wrap.nw-form-quick .nw-f-input-msg {
    width: 80px
  }

  .nw-form-wrap.nw-form-quick .nw-f-input-credentials {
    width: 132px
  }

  .nw-form-wrap.nw-form-quick .bank-selected {
    margin-top: -4px;
    width: auto;
    padding-right: 15px
  }

  .nw-form-wrap.nw-form-quick .bank-selected .bank-pre {
    color: #e31613;
    margin-left: 20px
  }

  .nw-form-wrap.nw-form-quick .coupon-select select {
    width: 300px
  }

  .nw-form-wrap.nw-form-quick .coupon-select select em {
    color: #999
  }

  .nw-form-wrap.nw-form-quick .coupon-select .coupon-tips {
    color: #999;
    margin-left: -135px;
    pointer-events: none
  }

  .nw-form-wrap.nw-form-quick .bank-credit-choose .pl-wrap {
    padding-bottom: 0
  }

  .nw-form-wrap.nw-form-quick .bank-credit-choose .instalment span {
    padding: 0 10px;
    color: #ddd
  }

  .nw-form-wrap.nw-form-quick .bank-credit-choose .pl-item {
    margin-bottom: 0;
    line-height: 28px;
    width: auto;
    padding: 1px 15px
  }

  .nw-form-wrap.nw-form-quick .bank-credit-choose .pl-item .pl-i-text {
    font-weight: 700
  }

  .nw-form-wrap.nw-form-quick .bank-credit-choose .pl-item .pl-i-fenqi {
    color: #999
  }

  .nw-form-wrap.nw-form-quick .bank-credit-choose .pl-item.selected .pl-i-fenqi, .nw-form-wrap.nw-form-quick .bank-credit-choose .pl-item.selected .pl-i-text {
    color: #e31613
  }

  .nw-form-wrap.nw-form-quick .bank-credit-choose .pl-item.disable {
    border-color: #e8e8e8;
    cursor: default
  }

  .nw-form-wrap.nw-form-quick .bank-credit-choose .pl-item.disable .pl-i-fenqi, .nw-form-wrap.nw-form-quick .bank-credit-choose .pl-item.disable .pl-i-text {
    color: #adadad
  }

  .nw-form-wrap.nw-form-quick .bank-credit-choose .bc-detail {
    clear: both
  }

  .nw-form-wrap.nw-form-quick .bank-credit-choose .bc-detail .bc-d-content {
    line-height: 24px
  }

  .nw-form-wrap.nw-form-quick .ui-button-gray {
    padding: 0 12px
  }

  .nw-form-wrap.nw-form-wangyin {
    padding: 4px 0 0 0
  }

  .nw-form-wrap.nw-form-wangyin .ui-form-line {
    position: relative
  }

  .nw-form-wrap.nw-form-wangyin .ui-form-line .pay-limit {
    position: absolute;
    width: 330px;
    right: -10px;
    top: 7px;
    z-index: 1
  }

  .pay-limit-list {
    background: #fff;
    margin-top: 6px
  }

  .pay-limit-list table {
    border-collapse: collapse
  }

  .pay-limit-list td, .pay-limit-list th {
    padding: 5px 10px;
    line-height: 18px;
    border: 1px solid #e2e2e2;
    word-break: break-all
  }

  .pay-limit-list th {
    background: #f2f2f2;
    text-align: left;
    font-weight: 400;
    color: #999
  }

  .nw-form-wrap.nw-form-wangyin .bank-selected {
    margin-top: -4px;
    width: auto;
    padding-right: 15px
  }

  .nw-form-wrap.nw-form-wangyin .bw-q-switch span {
    cursor: pointer
  }

  .nw-form-wrap.nw-form-wangyin .bw-q-switch span.ui-check-disable {
    cursor: default
  }

  .payment-change .o-icon-wrap {
    height: 35px;
    line-height: 15px;
    position: relative;
    text-align: left;
    margin-bottom: 15px
  }

  .payment-change .o-icon-wrap .o-icon {
    width: 102px;
    height: 35px;
    position: absolute;
    left: -34px;
    top: 0;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/title-other.png) no-repeat
  }

  .payment-change .o-icon-wrap .o-p-tips {
    line-height: 35px;
    color: #999;
    padding-left: 83px;
    opacity: .8
  }

  .payment-change .pc-wrap {
    display: block;
    height: 60px;
    line-height: 56px;
    padding: 0 20px;
    transition: all .1s
  }

  .payment-change .pc-wrap .pc-w-left {
    float: left;
    color: #ddd;
    font-size: 14px
  }

  .payment-change .pc-wrap .pc-w-left a {
    float: left;
    color: #5e5e5e;
    font-family: "Microsoft Yahei";
    font-size: 16px
  }

  .payment-change .pc-wrap .pc-w-left a:hover {
    color: #e31613
  }

  .payment-change .pc-wrap .pc-w-left a.disable {
    cursor: default;
    color: #999
  }

  .payment-change .pc-wrap .pc-w-left span {
    float: left;
    padding: 0 13px;
    font-size: 16px
  }

  .payment-change .pc-wrap .pc-w-left .pc-w-prom {
    font-size: 12px;
    color: #e31613;
    margin-left: 5px;
    cursor: default;
    font-family: Arial, Verdana, "\5b8b\4f53"
  }

  .payment-change .pc-wrap .pc-w-left .pc-item-jdpay, .payment-change .pc-wrap .pc-w-left .pc-item-pop {
    position: relative
  }

  .payment-change .pc-wrap .pc-w-left .pc-item-jdpay .item-icon, .payment-change .pc-wrap .pc-w-left .pc-item-pop .item-icon {
    display: inline-block;
    width: 16px;
    height: 18px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/qrcode-img.png) no-repeat 0 -26px;
    vertical-align: text-bottom;
    margin-left: -2px
  }

  .payment-change .pc-wrap .pc-w-left .pc-item-jdpay .item-tips, .payment-change .pc-wrap .pc-w-left .pc-item-pop .item-tips {
    font-size: 12px;
    font-style: normal;
    background: #99aecf;
    color: #fff;
    padding: 1px 6px 1px 5px;
    border-radius: 3px
  }

  .payment-change .pc-wrap .pc-w-left .pc-item-jdpay .item-pop, .payment-change .pc-wrap .pc-w-left .pc-item-pop .item-pop {
    left: 3px;
    top: -145px;
    z-index: 15;
    position: absolute;
    width: 100px;
    padding: 10px;
    display: none;
    background: #fff;
    border: 1px solid #e8e8e8;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, .1);
    border-radius: 2px;
    line-height: 16px;
    text-align: center
  }

  .payment-change .pc-wrap .pc-w-left .pc-item-jdpay .item-pop b, .payment-change .pc-wrap .pc-w-left .pc-item-pop .item-pop b {
    font-size: 12px;
    line-height: 16px;
    display: inline;
    font-style: normal;
    color: #ff5256;
    font-family: Arial, Verdana, "\5b8b\4f53"
  }

  .payment-change .pc-wrap .pc-w-left .pc-item-jdpay:hover .item-pop, .payment-change .pc-wrap .pc-w-left .pc-item-pop:hover .item-pop {
    display: block
  }

  .payment-change .pc-wrap .pc-w-left .pc-item-jdpay:hover .item-icon, .payment-change .pc-wrap .pc-w-left .pc-item-pop:hover .item-icon {
    background-position: top
  }

  .payment-change .pc-wrap .pc-w-left .pc-item-pop .item-tips-content {
    left: 44px;
    top: -24px;
    z-index: 15;
    position: absolute;
    width: 160px;
    padding: 10px 5px;
    display: none;
    background: #fff;
    border: 1px solid #e8e8e8;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, .1);
    border-radius: 2px;
    line-height: 16px;
    text-align: center;
    font-style: normal
  }

  .payment-change .pc-wrap .pc-w-left .pc-item-pop:hover .item-tips-content {
    display: block;
    color: #5e5e5e
  }

  .payment-change .pc-wrap .pc-w-right {
    display: block;
    margin-left: 350px;
    padding-left: 40px
  }

  .payment-change .pc-wrap strong {
    color: #67a4ff;
    margin-right: 30px;
    font-size: 14px;
    float: left;
    cursor: pointer
  }

  .payment-change .pc-wrap em {
    color: #999;
    font-style: normal;
    float: left;
    cursor: pointer
  }

  .payment-change .pc-wrap .pc-w-arrow-left, .payment-change .pc-wrap .pc-w-arrow-right {
    float: right;
    font-family: "\5b8b\4f53";
    font-style: normal;
    font-size: 22px;
    width: 20px;
    text-align: center;
    color: #2fa1dd
  }

  .payment-change .pc-wrap .pc-w-arrow-left {
    float: left;
    margin-right: 15px
  }

  .payment {
    background-color: #fff;
    padding: 12px 30px;
    box-shadow: 0 6px 32px rgba(0, 0, 0, .13)
  }

  .payment.payment-new .pc-w-left .pay-wrap {
    padding-left: 8px;
    float: left;
    cursor: pointer;
    position: relative
  }

  .payment.payment-new .pc-w-left .pay-wrap:hover .badatong-unfold {
    display: block
  }

  .payment.payment-new .pc-w-left .pay-wrap .badatong-unfold {
    display: none;
    position: absolute;
    bottom: 50px;
    left: -64px;
    width: 233px;
    height: 122px;
    background: url(//img30.360buyimg.com/jr_image/jfs/t12775/265/2536287120/2678/28dc5ec/5a41ed11N934c23bd.png) center no-repeat
  }

  .payment.payment-new .pc-w-left .pay-wrap .badatong-unfold .iner {
    cursor: auto;
    padding: 15px;
    font-size: 13px;
    padding-bottom: 25px
  }

  .payment.payment-new .pc-w-left .pay-wrap .badatong-unfold .iner p {
    color: #5e5e5e;
    line-height: 20px
  }

  .payment.payment-new .pc-w-left .pay-wrap .badatong-unfold .iner p b {
    color: #e31613
  }

  .payment.payment-new .pc-w-left .pay-wrap .badatong-unfold .iner p.tip {
    color: #ccc;
    font-size: 12px
  }

  .payment.payment-new .pc-w-left > span {
    padding: 0 40px
  }

  .payment.payment-new .pc-w-left i.icon {
    display: inline-block;
    position: relative;
    right: 8px;
    top: -1px;
    width: 26px;
    height: 26px
  }

  .payment.payment-new .pc-w-left i.icon img {
    max-width: 100%;
    max-height: 100%
  }

  #modal_couponLead .modal-content {
    font-family: "Microsoft YaHei";
    font-size: 24px;
    line-height: 36px;
    color: #000;
    text-align: left;
    padding-left: 60px;
    position: relative;
    margin-bottom: 40px
  }

  #modal_couponLead .modal-content .red {
    color: #e31613
  }

  #modal_couponLead .modal-content:before {
    content: '';
    display: inline-block;
    position: absolute;
    width: 46px;
    height: 46px;
    left: 0;
    background: url(//img30.360buyimg.com/jr_image/jfs/t16924/169/550777403/429/592040a5/5a964bf3N5ff0974d.png) no-repeat
  }

  #modal_couponLead .ui-button {
    height: 40px;
    box-sizing: border-box;
    text-align: center;
    line-height: 40px;
    background: #f9f9f9;
    padding: 0 28px;
    color: #5e5e5e;
    font-size: 16px;
    border: 1px solid #ececec;
    box-shadow: none
  }

  #modal_couponLead .ui-button.ui-button-confirm {
    border: none;
    background: #e31613;
    margin-right: 15px;
    color: #fff;
    margin-left: 50px
  }

  #modal_bindCard {
    width: 450px
  }

  #modal_bindCard .inner-title {
    font-size: 18px;
    font-weight: 700;
    color: #333;
    margin-bottom: 25px;
    text-align: center
  }

  #modal_bindCard .form-item label {
    width: 90px;
    text-align: right;
    display: inline-block;
    color: #666
  }

  #modal_bindCard .form-item input {
    width: 220px;
    height: 37px;
    box-sizing: border-box;
    padding-left: 10px;
    margin: 10px;
    border: 1px solid #c6c6c6;
    border-radius: 2px
  }

  #modal_bindCard .form-item p.error {
    font-size: 12px;
    color: #ff5e5c;
    margin-left: 100px
  }

  #modal_bindCard .confirmPay {
    margin-left: 30px;
    margin-top: 10px
  }

  #modal_bindCard .confirmPay span.error {
    display: inline-block;
    line-height: 48px;
    height: 48px
  }

  #modal_bindCard .bindCardError {
    margin-left: 100px;
    font-size: 12px;
    color: #ff5e5c
  }

  #modal_bindCard .vc-loading {
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/ui-button-XL-loading.gif) no-repeat center;
    display: inline-block;
    width: 218px;
    height: 46px;
    border: 1px solid #ff5e5c;
    border-radius: 2px
  }

  .fqInfo {
    position: relative;
    line-height: 32px;
    height: 32px;
    margin-bottom: 5px
  }

  .fqInfo.toggleBankList .fq-bankList {
    display: block
  }

  .fqInfo .fqBank {
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
    width: 365px;
    height: 32px;
    line-height: 32px;
    border: 1px solid #d0d0d0;
    border-radius: 2px;
    padding: 0 12px
  }

  .fqInfo .fqBank img {
    position: relative;
    top: -1px;
    margin-right: 4px
  }

  .fqInfo .fqBank .icon-down {
    width: 6px;
    height: 3px;
    display: inline-block;
    position: absolute;
    top: 50%;
    margin-top: -1px;
    right: 10px;
    transition: all .1s;
    background: url(//img30.360buyimg.com/jr_image/jfs/t16129/159/2109606240/89/a42246df/5a94bd4eNd7ad6171.png) no-repeat
  }

  .fqInfo .fqBank .icon-down.top {
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg)
  }

  .fqInfo .fqBank .span2 {
    color: #e31613;
    margin-right: 15px;
    float: right;
    width: 190px;
    text-align: right
  }

  .fqInfo .fqBank .span3 {
    float: right;
    margin-right: 20px;
    width: 250px
  }

  .fq-bankList {
    box-sizing: border-box;
    width: 365px;
    position: absolute;
    min-height: 35px;
    left: 0;
    top: 31px;
    background: #fff;
    z-index: 9999;
    border: 1px solid #c6c6c6;
    border-top: 0
  }

  .fq-bankList .bank-item {
    margin: 0 12px;
    position: relative;
    cursor: pointer
  }

  .fq-bankList .bank-item:first-child {
    border-top: 1px solid #eee
  }

  .fq-bankList .bank-item .span1 {
    margin-left: 6px;
    position: relative;
    top: 1px
  }

  .fq-bankList .bank-item .span2 {
    color: #e31613;
    margin-right: 15px;
    width: 190px;
    float: right;
    text-align: right
  }

  .fq-bankList .bank-item .span3 {
    float: right;
    margin-right: 15px;
    width: 250px
  }

  .fq-bankList .bank-item.active:after {
    content: '';
    position: absolute;
    display: inline-block;
    width: 9px;
    height: 7px;
    top: 50%;
    margin-top: -3px;
    right: 0;
    background: url(//img30.360buyimg.com/jr_image/jfs/t17692/236/548922145/123/476f4744/5a94c569Na3c7a49d.png) no-repeat
  }

  .fq-bankList .bank-item.disabled img {
    opacity: .5
  }

  .fq-bankList .bank-item.disabled .span1 {
    color: #ccc
  }

  .fq-bankList .bank-item.disabled .span2 {
    color: #999
  }

  .fq-bankList .bank-item.disabled .span3 {
    color: #999
  }

  .recomItem .recomBank {
    position: relative;
    top: -1px;
    margin-right: 6px
  }

  .recomItem:after {
    content: '';
    display: inline-block;
    width: 5px;
    height: 8px;
    top: 50%;
    margin-top: -4px;
    right: 0;
    position: absolute;
    background: url(//img30.360buyimg.com/jr_image/jfs/t17728/112/561352613/1296/facbe48f/5a950475N5e5279c5.jpg) no-repeat
  }

  .nw-form-wrap.nw-form-quick .bank-list {
    box-sizing: border-box;
    width: 230px;
    position: absolute;
    min-height: 35px;
    left: 0;
    top: 31px;
    background: #fff;
    z-index: 99;
    border: 1px solid #c6c6c6;
    border-top: 0
  }

  .nw-form-wrap.nw-form-quick .bank-list .bank-item {
    margin: 0 10px;
    position: relative;
    cursor: pointer
  }

  .nw-form-wrap.nw-form-quick .bank-list .bank-item:first-child {
    border-top: 1px solid #eee
  }

  .nw-form-wrap.nw-form-quick .bank-list .bank-item .span1 {
    margin-left: 6px;
    font-weight: 700;
    position: relative;
    top: 1px
  }

  .nw-form-wrap.nw-form-quick .bank-list .bank-item.active:after {
    content: '';
    position: absolute;
    display: inline-block;
    width: 9px;
    height: 7px;
    top: 50%;
    margin-top: -3px;
    right: 0;
    background: url(//img30.360buyimg.com/jr_image/jfs/t17692/236/548922145/123/476f4744/5a94c569Na3c7a49d.png) no-repeat
  }

  .nw-form-wrap.nw-form-quick .ui-form-line.xykfq .pl-item {
    box-sizing: border-box;
    min-width: 140px;
    height: 50px;
    margin-bottom: 10px
  }

  .nw-form-wrap.nw-form-quick .ui-form-line.xykfq .pl-item .pl-i-text {
    display: block;
    padding-top: 2px;
    line-height: 22px;
    font-weight: 700
  }

  .nw-form-wrap.nw-form-quick .ui-form-line.xykfq .pl-item .pl-i-fenqi {
    line-height: 22px;
    display: block;
    color: #999
  }

  .jingxijin > span img {
    position: relative;
    top: -1px;
    margin-right: 5px
  }

  .fqInfo.jingxijinInfo .fqBank {
    width: 430px
  }

  .fqInfo.jingxijinInfo .fq-bankList {
    width: 430px
  }

  .paybox-newcard {
    border-bottom: 0 none;
    padding-top: 20px;
    padding-left: 70px
  }

  .paybox-newcard .pn-more {
    height: 34px;
    line-height: 34px;
    width: 138px;
    border: 1px solid #e0e0e0;
    display: inline-block;
    position: relative;
    text-align: center;
    margin-right: 10px
  }

  .paybox-newcard .pn-more i {
    right: 20px;
    top: 11px;
    position: absolute;
    display: block;
    width: 12px;
    height: 12px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png?20160328) no-repeat -76px -75px
  }

  .paybox-newcard .pn-more:hover i {
    background-position: -76px -221px
  }

  .paybox-newcard .pn-new {
    height: 34px;
    line-height: 34px;
    width: 170px;
    border: 1px solid #e0e0e0;
    display: inline-block;
    position: relative;
    text-align: center
  }

  .supportBank i {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url(//storage.jd.com/payment-assets/pc/icon/supportTip.png);
    position: relative;
    top: 3px;
    left: 2px
  }

  .supportBank:hover .supportBankList {
    display: block
  }

  .supportBankList {
    display: none;
    padding: 15px;
    left: 300px;
    top: 28px;
    width: 250px;
    height: 130px;
    box-sizing: border-box;
    position: absolute;
    background: #fff;
    box-shadow: 0 0 5px #ededed;
    overflow-y: auto
  }

  .supportBankList ul li {
    width: 50%;
    float: left;
    color: #666
  }

  .shenfen i {
    display: inline-block;
    width: 6px;
    height: 3px;
    background: url(//storage.jd.com/payment-assets/pc/icon/i-bottom.png);
    position: relative;
    left: 3px;
    top: -2px
  }

  .identific {
    margin-left: 160px;
    padding-left: 10px;
    margin-top: 10px;
    font-weight: 700
  }

  .identific img {
    margin-right: 5px
  }

  .credentials {
    position: absolute;
    z-index: 10;
    background: #fff;
    width: 110px;
    border: 1px solid #c6c6c6;
    left: 20px
  }

  .credentials > li {
    margin: 0 10px;
    text-align: right;
    border-bottom: 1px solid #ededed;
    padding: 8px 0;
    cursor: pointer
  }

  .credentials > li i {
    display: inline-block;
    width: 6px;
    height: 3px;
    background: url(//storage.jd.com/payment-assets/pc/icon/i-bottom.png);
    position: relative;
    left: 3px;
    top: -2px
  }

  .credentials > li.active {
    color: #e31613
  }

  .channelTab {
    border-bottom: 1px solid #eee;
    padding-top: 20px;
    padding-left: 20px
  }

  .channelTab:after {
    content: '';
    display: block;
    height: 0;
    clear: both
  }

  .channelTab .channelItem {
    float: left;
    font-weight: 700;
    width: 110px;
    text-align: center;
    cursor: pointer;
    margin-bottom: -1px
  }

  .channelTab .channelItem a {
    border-radius: 3px 3px 0 0;
    line-height: 34px;
    font-size: 14px;
    height: 34px;
    border-bottom: 0;
    color: #999;
    display: inline-block;
    font-size: 14px
  }

  .channelTab .channelItem.active {
    border: 1px solid #eee;
    border-bottom: 1px solid #fff
  }

  .channelTab .channelItem.active a {
    height: 35px;
    color: #333
  }

  .decorate-modal {
    width: 470px
  }

  .decorate-modal .ui-modal-content {
    padding-left: 50px;
    padding-right: 50px
  }

  .decorate-modal .dc-title {
    font-size: 18px;
    font-family: "Microsoft Yahei";
    font-weight: 700;
    color: #333;
    line-height: 20px;
    margin-bottom: 15px
  }

  .decorate-modal .dc-title em {
    color: #e31613
  }

  .decorate-modal .dc-content {
    font-size: 14px;
    font-family: "Microsoft Yahei";
    line-height: 20px
  }

  .decorate-modal .dc-operations {
    text-align: center;
    padding: 40px 0 10px 0
  }

  .decorate-modal .dc-operations .ui-button-XL {
    width: 170px
  }

  .used-bank {
    float: left;
    position: relative;
    z-index: 1
  }

  .used-bank dt {
    position: relative;
    cursor: pointer;
    width: 492px;
    height: 30px;
    border: 1px solid #b0c2e1;
    line-height: 30px;
    border-radius: 2px;
    background-color: #fff;
    overflow: hidden;
    transition: border-color .1s
  }

  .used-bank dt .ui-icon-arrow {
    position: absolute;
    top: 8px;
    right: 8px
  }

  .used-bank dt .ub-arrow {
    position: absolute;
    top: 0;
    right: 0;
    width: 31px;
    height: 30px;
    background: #b0c2e1 url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png?20160328) no-repeat 8px -310px;
    transition: background-color .1s
  }

  .used-bank dt:hover {
    border-color: #e31613
  }

  .used-bank dt:hover .ub-arrow {
    background-color: #e31613
  }

  .used-bank dd {
    position: absolute;
    z-index: 21;
    left: 0;
    top: -10px;
    background-color: #fff;
    width: 492px;
    border: 1px solid #e8e8e8;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, .2)
  }

  .used-bank .ub-item {
    overflow: hidden
  }

  .used-bank .ub-item .bank-logo {
    float: left;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 1px
  }

  .used-bank .ub-item em {
    float: left
  }

  .used-bank .ub-item .p-div {
    float: left;
    margin: 0 5px
  }

  .used-bank .ub-item .ui-icon-arrow {
    float: right;
    margin-left: 10px;
    margin-top: 8px;
    margin-right: 10px
  }

  .used-bank .ub-item .ub-i-quick, .used-bank .ub-item .ub-i-wangyin {
    margin-top: 6px;
    background: #83a4dc;
    color: #fff;
    height: 18px;
    line-height: 18px;
    padding: 0 5px;
    margin-right: 5px;
    border-radius: 2px
  }

  .used-bank .ub-item .ub-i-wangyin {
    background: #83a4dc
  }

  .used-bank .ub-item .ub-i-limit {
    color: #999
  }

  .used-bank .ub-item .ub-i-limit.font-red {
    color: #e31613
  }

  .used-bank .ub-item .bank-pre {
    margin-left: 20px;
    color: #e31613
  }

  .used-bank .ub-item.bank-disable {
    opacity: .5;
    cursor: default
  }

  .used-bank .ub-item.bank-disable:hover {
    background-color: #fff
  }

  .used-bank .ub-list {
    padding: 10px 0 5px 0
  }

  .used-bank .ub-list li {
    position: relative;
    *zoom: 1;
    cursor: pointer;
    margin-bottom: 5px;
    line-height: 30px
  }

  .used-bank .ub-list li i {
    display: none;
    position: absolute;
    right: 8px;
    top: 12px;
    width: 10px;
    height: 10px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png?20160328) no-repeat -44px -172px
  }

  .used-bank .ub-list li.selected, .used-bank .ub-list li:hover {
    background-color: #d8f1ff
  }

  .used-bank .ub-list li.selected i {
    display: block
  }

  .used-bank.used-bank-eBank dt {
    width: 305px
  }

  .used-bank.used-bank-eBank dd {
    width: 305px
  }

  .j_usedBankDisable .ub-item {
    opacity: .5;
    cursor: default
  }

  .bank-return a i {
    font-family: "\5b8b\4f53";
    font-style: normal;
    margin-right: 5px
  }

  .bank-limit {
    float: left
  }

  .bank-limit .bl-title a {
    cursor: default;
    display: inline-block;
    line-height: 20px
  }

  .bank-limit .bl-title a i {
    display: inline-block;
    width: 10px;
    height: 14px;
    vertical-align: middle;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png?20160328) no-repeat -79px -143px;
    margin-right: 5px
  }

  .bank-limit .bl-title a:hover i {
    background-position: -79px -171px
  }

  .bank-new {
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    border: 1px solid #b1c3e0;
    border-radius: 2px;
    color: #8598b6;
    margin-left: 10px
  }

  .bank-new:hover {
    color: #e31613;
    border-color: #e31613
  }

  .bank-new:hover .bn-icon {
    color: #e31613
  }

  .bank-new .bn-icon {
    width: 10px;
    height: 10px;
    margin-top: 10px;
    *margin-top: 4px;
    margin-right: 6px;
    float: left;
    font-family: "microsoft yahei";
    font-size: 20px;
    *line-height: 16px;
    line-height: 7px;
    margin-left: -1px
  }

  .bank-area {
    padding: 15px 58px 0 58px
  }

  .baitiao-selector {
    height: 32px;
    line-height: 32px;
    padding-left: 10px;
    margin-top: 10px
  }

  .baitiao-selector .bs-check {
    float: left;
    cursor: pointer
  }

  .baitiao-selector .bs-check span {
    vertical-align: baseline;
    display: inline-block
  }

  .baitiao-selector .bs-check em {
    color: #e31613
  }

  .baitiao-selector .bs-check-use {
    background-color: #f7f7f7;
    padding-left: 10px;
    position: relative;
    z-index: 20;
    line-height: 32px;
    *zoom: 1
  }

  .baitiao-selector .bs-fenqi-pop {
    position: absolute;
    left: -1px;
    top: 30px;
    width: 315px;
    padding: 15px 20px;
    background: #fff;
    border: 1px solid #e8e8e8;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, .2);
    cursor: default;
    z-index: 21;
    display: none
  }

  .baitiao-selector .bs-fenqi-pop .bs-p-close {
    position: absolute;
    display: block;
    right: 18px;
    top: 16px;
    width: 20px;
    height: 20px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png?20160328) no-repeat -39px -221px
  }

  .baitiao-selector .bs-fenqi-pop .bs-p-title {
    line-height: 20px;
    margin-bottom: 10px
  }

  .baitiao-selector .bs-fenqi-pop .bs-p-content table {
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
    width: 100%
  }

  .baitiao-selector .bs-fenqi-pop .bs-p-content table td, .baitiao-selector .bs-fenqi-pop .bs-p-content table th {
    padding: 0;
    line-height: 32px;
    text-align: left;
    padding-left: 20px
  }

  .baitiao-selector .bs-fenqi-pop .bs-p-content table th {
    background-color: #f7f7f7;
    font-weight: 400
  }

  .baitiao-selector .bs-fenqi-pop .bs-p-content table .tr-baitiao td {
    color: #69cd8e;
    border-bottom: 1px solid #ddd
  }

  .baitiao-selector .bs-check-use.hover .bs-fenqi-pop {
    display: block
  }

  .baitiao-selector .bs-select {
    background-color: #f7f7f7;
    float: left;
    position: relative;
    width: 430px
  }

  .baitiao-selector .bs-select dt {
    color: #c5c5c5;
    padding-left: 10px;
    cursor: pointer
  }

  .baitiao-selector .bs-select dt .ui-icon-arrow {
    position: absolute;
    top: 9px;
    right: 8px
  }

  .baitiao-selector .bs-select dd {
    position: absolute;
    z-index: 21;
    left: -1px;
    top: -11px;
    background-color: #fff;
    width: 440px;
    border: 1px solid #e8e8e8;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, .2)
  }

  .baitiao-selector .bs-select .bs-s-list {
    padding: 10px 0
  }

  .baitiao-selector .bs-select .bs-s-list li {
    position: relative;
    *zoom: 1;
    padding-left: 10px;
    cursor: pointer
  }

  .baitiao-selector .bs-select .bs-s-list li i {
    display: none;
    position: absolute;
    right: 8px;
    top: 12px;
    width: 10px;
    height: 10px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/elements.png?20160328) no-repeat -44px -172px
  }

  .baitiao-selector .bs-select .bs-s-list li:hover {
    background-color: #f0faff
  }

  .baitiao-selector .bs-select .bs-s-list li.selected i {
    display: block
  }

  .baitiao-selector.fenqi-check .bs-check-use {
    border: 1px solid #b0c2e1;
    border-right: 0;
    line-height: 30px;
    background: #fff
  }

  .baitiao-selector.fenqi-check .bs-select {
    border: 1px solid #b0c2e1;
    border-left: 0;
    background: #fff;
    line-height: 30px
  }

  .baitiao-selector.fenqi-check .bs-select dt {
    color: #666
  }

  .card-sync {
    width: 240px;
    height: 147px;
    position: absolute;
    left: 580px;
    top: 99px;
    perspective: 500
  }

  .card-sync .cs-back, .card-sync .cs-front {
    transition: all .3s ease-in-out
  }

  .card-sync .cs-front {
    position: absolute;
    left: 0;
    top: 0;
    width: 238px;
    height: 145px;
    border: 1px solid #f0f0f0;
    border-radius: 5px;
    box-shadow: 0 0 20px rgba(0, 0, 0, .1);
    opacity: 1;
    transform: rotateY(0);
    -webkit-backface-visibility: visible;
    backface-visibility: visible
  }

  .card-sync .cs-front .cs-bank {
    position: absolute;
    left: 5px;
    top: 10px
  }

  .card-sync .cs-front .cs-bank-tips {
    position: absolute;
    left: 22px;
    top: 11px;
    display: block;
    height: 28px;
    line-height: 28px
  }

  .card-sync .cs-front .cs-cardType {
    position: absolute;
    left: 132px;
    top: 15px;
    height: 20px;
    line-height: 20px
  }

  .card-sync .cs-front .cs-limit {
    position: absolute;
    right: 10px;
    top: 15px;
    height: 20px;
    line-height: 20px;
    padding-right: 15px;
    cursor: default
  }

  .card-sync .cs-front .cs-limit i {
    display: block;
    position: absolute;
    right: 2px;
    top: 8px;
    width: 8px;
    height: 4px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/card-arrow.png) no-repeat
  }

  .card-sync .cs-front .cs-limit em {
    display: block;
    position: absolute;
    right: -9px;
    bottom: -111px;
    width: 238px;
    height: 38px;
    background-color: rgba(253, 124, 124, .95);
    border-radius: 0 0 5px 5px;
    line-height: 38px;
    text-align: center;
    z-index: 10;
    color: #fff;
    visibility: hidden;
    opacity: 0;
    transition: opacity .1s ease-in-out
  }

  .card-sync .cs-front .cs-limit:hover em {
    visibility: visible;
    opacity: 1
  }

  .card-sync .cs-front .cs-cardNumber {
    position: absolute;
    left: 17px;
    top: 72px;
    height: 26px;
    line-height: 26px;
    font-size: 18px
  }

  .card-sync .cs-front .cs-cardNumber.cs-cardNumber-up23 {
    font-size: 14px
  }

  .card-sync .cs-front .cs-valid {
    position: absolute;
    left: 17px;
    top: 103px;
    height: 18px;
    line-height: 18px;
    font-size: 12px;
    padding-left: 30px
  }

  .card-sync .cs-front .cs-valid i {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    height: 18px;
    width: 24px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/card-valid.png) no-repeat
  }

  .card-sync .cs-front .cs-org {
    position: absolute;
    right: 10px;
    top: 102px;
    width: 54px;
    height: 34px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/card-unionpay.png) no-repeat
  }

  .card-sync .cs-back {
    position: absolute;
    left: 0;
    top: 0;
    width: 238px;
    height: 145px;
    border: 1px solid #f0f0f0;
    border-radius: 5px;
    box-shadow: 0 0 20px rgba(0, 0, 0, .1);
    opacity: 0;
    transform: rotateY(-180deg);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden
  }

  .card-sync .cs-back .cs-line {
    position: absolute;
    width: 238px;
    height: 40px;
    top: 14px;
    background: #c4c4c4
  }

  .card-sync .cs-back .cs-cvv2 {
    position: absolute;
    width: 120px;
    height: 26px;
    line-height: 26px;
    top: 60px;
    left: 60px;
    background: #efefef
  }

  .card-sync .cs-back .cs-cvv2 i {
    padding-left: 26px;
    margin-right: 10px;
    font-style: normal;
    color: #999
  }

  .card-sync .cs-back .cs-cvv2 em {
    color: #666
  }

  .card-sync.toggleBack .cs-front {
    opacity: 0;
    transform: rotateY(180deg);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden
  }

  .card-sync.toggleBack .cs-back {
    opacity: 1;
    transform: rotateY(0);
    -webkit-backface-visibility: visible;
    backface-visibility: visible
  }

  .fang-ui-modal {
    width: 624px;
    height: 400px;
    display: none;
    position: absolute;
    box-sizing: border-box;
    left: 50%;
    margin-left: -312px;
    top: 50%;
    margin-top: -200px;
    z-index: 10001;
    border: 8px solid #b2b2b2;
    background: #fff
  }

  .fang-ui-modal-head {
    background: #f7f7f7;
    box-sizing: border-box;
    position: relative;
    height: 72px;
    padding: 15px 30px
  }

  .fang-ui-modal-head h3 {
    font-size: 14px;
    color: #666;
    font-weight: 700
  }

  .fang-ui-modal-head p {
    font-size: 12px;
    color: #999
  }

  .fang-ui-modal-head .um-h-close {
    position: absolute;
    width: 16px;
    height: 16px;
    display: inline-block;
    cursor: pointer;
    background: url(//img30.360buyimg.com/jr_image/jfs/t20896/255/272002980/170/a5d26d62/5b07b800N737e0819.png) no-repeat;
    background-size: cover;
    top: 16px;
    right: 16px
  }

  .fang-ui-modal-content {
    overflow-y: auto;
    padding: 0 30px;
    height: 312px
  }

  .fang-ui-modal-content .item {
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    height: 85px;
    padding: 18px 0
  }

  .fang-ui-modal-content .item:after {
    content: '';
    display: block;
    height: 0;
    clear: both
  }

  .fang-ui-modal-content .item > div {
    float: left
  }

  .fang-ui-modal-content .item .img {
    width: 53px;
    height: 53px
  }

  .fang-ui-modal-content .item .info {
    width: 265px;
    margin: 0 20px;
    font-size: 12px;
    color: #666;
    padding-top: 10px
  }

  .fang-ui-modal-content .item .num {
    line-height: 53px;
    margin-left: 40px
  }

  .fang-ui-modal-content .item .price {
    color: #e31613;
    font-size: 20px;
    line-height: 53px;
    margin-left: 40px
  }

  .pr {
    position: relative
  }

  .loginPage.payment {
    padding: 0
  }

  .loginPage .jp-logo-wrap .jp-logo {
    background: url(//img30.360buyimg.com/jr_image/jfs/t16804/155/1531823198/845/5cd2e2bb/5acf0711N68b105f8.png) no-repeat;
    left: 0;
    top: 12px
  }

  .loginPage .jp-logo-wrap .jp-logo.codePay {
    background: url(//img30.360buyimg.com/jr_image/jfs/t18271/241/1544370551/750/2448818f/5acf1f29N87201027.png) no-repeat
  }

  .loginWrap {
    height: 480px
  }

  .loginWrap .leftInput {
    width: 350px;
    height: 350px;
    margin-left: 230px;
    margin-top: 130px;
    float: left
  }

  .loginWrap .leftInput.phoneLogin {
    margin-left: 335px;
    margin-top: 100px
  }

  .loginWrap .leftInput.phoneLogin .ui-form .ui-form-label {
    font-size: 12px;
    font-weight: 400
  }

  .loginWrap .leftInput.phoneLogin .ui-form .ui-input {
    width: 309px;
    height: 37px;
    box-sizing: border-box
  }

  .loginWrap .leftInput.phoneLogin .ui-form .rl-c-msg .ui-input {
    width: 213px
  }

  .loginWrap .leftInput.phoneLogin .ui-button-XL {
    width: 309px
  }

  .loginWrap .leftInput .ui-form h3 {
    margin-left: 15px;
    font-size: 24px;
    margin-bottom: 45px
  }

  .loginWrap .leftInput .ui-form .ui-form-label {
    display: block;
    float: none;
    width: auto;
    text-align: left;
    font-size: 14px;
    font-weight: 700
  }

  .loginWrap .leftInput .ui-form .rl-c-msg .ui-input {
    width: 127px
  }

  .loginWrap .leftCode .recommed a {
    display: inline-block;
    width: 20px;
    height: 20px;
    position: relative;
    top: 3px
  }

  .loginWrap .auth .auth-img img {
    width: 95px;
    height: 95px;
    border-radius: 100%;
    cursor: pointer
  }

  .loginWrap .rightTag .codePay.active p {
    color: #484f5f
  }

  .loginWrap .rightTag .loginPay.active p {
    color: #484f5f
  }

  .loginPage .payment {
    padding: 0
  }

  .codePay .leftCode .recommed a {
    display: inline-block;
    width: 20px;
    height: 20px;
    position: relative;
    top: 3px
  }

</style>



// WEBPACK FOOTER //
// src/pay.vue